import { useState, useEffect } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, collection, onSnapshot, addDoc, updateDoc, deleteDoc, doc, setDoc, getDoc, arrayUnion, arrayRemove, query, where, getDocs, increment } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA_v3_9lSVgZkwafLw7bLpmOfzbPpdyCCQ",
  authDomain: "mosaiq-01.firebaseapp.com",
  projectId: "mosaiq-01",
  storageBucket: "mosaiq-01.firebasestorage.app",
  messagingSenderId: "291116691112",
  appId: "1:291116691112:web:4d54df710386fff06fdc9d"
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

const C = {
  bg: "#F7F5F0", surface: "#FFFFFF", cardAlt: "#F0EDE6",
  border: "#E2DDD5", accent: "#1E3D1A", accentMid: "#2D5C27", accentLight: "#EAF0E9",
  accentSoft: "#C8D9C5", text: "#1A2818", textMuted: "#6B7E67", textLight: "#A0B09B",
  yellow: "#B8860B", yellowLight: "#FBF5E0", blue: "#2C6B7A", blueLight: "#E5F2F5",
  coral: "#A0522D", coralLight: "#FAF0E8", tag: "#EAF0E9",
};

const ADMIN_PASSWORD = "mosaiq2026";

const DEFAULT_SPOTS = [
  { id: 1, name: "Intense Coffee", category: "Coffee Spot", area: "Limpertsberg", rating: 4.8, tags: ["Vegan", "Cosy"], saves: 142, pick: true, emoji: "☕", description: "Best oat flat white in the city. Tiny, tucked away, worth finding.", address: "14 Rue de la Forêt, Limpertsberg" },
  { id: 2, name: "Mullerthal Trail", category: "Sports", area: "Mullerthal", rating: 4.9, tags: ["Hiking", "Nature"], saves: 89, pick: true, emoji: "⛰️", description: "Luxembourg Little Switzerland. Stunning rock formations, 3 different trail lengths.", address: "Mullerthal, Luxembourg" },
  { id: 3, name: "Rotondes", category: "Culture", area: "Bonnevoie", rating: 4.6, tags: ["Music", "Events"], saves: 201, pick: false, emoji: "🎵", description: "The coolest cultural venue in Luxembourg. Always something interesting on.", address: "Place des Rotondes, Bonnevoie" },
  { id: 4, name: "Scott Pub", category: "Bar", area: "City Centre", rating: 4.3, tags: ["Expat", "Sports TV"], saves: 67, pick: false, emoji: "🍺", description: "The expat living room. Every nation represented, sport always on.", address: "13 Rue Beaumont, City Centre" },
  { id: 5, name: "Piscine Bonnevoie", category: "Sports", area: "Bonnevoie", rating: 4.1, tags: ["Swimming", "Fitness"], saves: 44, pick: false, emoji: "🏊", description: "Clean, uncrowded, great lanes. Perfect for morning swims.", address: "Rue de Bonnevoie 135, Bonnevoie" },
];

const DEFAULT_EVENTS = [
  { id: 1, title: "Sunday Morning Pilates", type: "Sports", area: "Kirchberg", date: "05/04/2026", time: "8:00", joined: 7, max: 12, host: "Joana S.", avatar: "J", emoji: "🧘", color: "#1E3D1A", colorLight: "#EAF0E9", description: "A relaxed Sunday morning pilates session in Kirchberg. All levels welcome!", meetingPoint: "Pescatore Park, City Center", duration: "~1h 30min" },
  { id: 2, title: "Meet-New-People Brunch", type: "Social", area: "Grund", date: "12/04/2026", time: "11:00", joined: 14, max: 20, host: "Sarah T.", avatar: "S", emoji: "🥐", color: "#B8860B", colorLight: "#FBF5E0", description: "Monthly meet-new-people brunch. Come hungry, come sociable!", meetingPoint: "Beim Engel, Grund", duration: "~2h" },
  { id: 3, title: "5-a-side Football", type: "Sports", area: "Gasperich", date: "03/04/2026", time: "21:00", joined: 8, max: 10, host: "Pedro H.", avatar: "P", emoji: "⚽", color: "#2C6B7A", colorLight: "#E5F2F5", description: "Weekly 5-a-side football. Mixed ability, just bring good energy.", meetingPoint: "Indoor pitch, Gasperich Sports Centre", duration: "~1h" },
  { id: 4, title: "Board Games Evening", type: "Social", area: "Limpertsberg", date: "18/04/2026", time: "18:30", joined: 5, max: 6, host: "Claire D.", avatar: "C", emoji: "🎲", color: "#A0522D", colorLight: "#FAF0E8", description: "Board games with new people. Wine and cheese included.", meetingPoint: "Cave des Sommeliers, Limpertsberg", duration: "~2h 30min" },
  { id: 5, title: "Morning Run — Kirchberg", type: "Sports", area: "Kirchberg", date: "28/03/2026", time: "7:30", joined: 9, max: 15, host: "Pedro H.", avatar: "P", emoji: "🏃", color: "#1E3D1A", colorLight: "#EAF0E9", description: "Easy 5k run around Kirchberg. All paces welcome.", meetingPoint: "Philharmonie steps", duration: "~45min" },
  { id: 6, title: "Wine Tasting Evening", type: "Social", area: "Clausen", date: "25/03/2026", time: "19:00", joined: 12, max: 16, host: "Sarah T.", avatar: "S", emoji: "🍷", color: "#A0522D", colorLight: "#FAF0E8", description: "A guided tasting of Luxembourg and Moselle wines. Very civilised.", meetingPoint: "Cave Wengler, Clausen", duration: "~2h" },
];

const EVENT_COLORS = [
  { label: "Forest", color: "#1E3D1A", colorLight: "#EAF0E9" },
  { label: "Yellow", color: "#B8860B", colorLight: "#FBF5E0" },
  { label: "Blue", color: "#2C6B7A", colorLight: "#E5F2F5" },
  { label: "Coral", color: "#A0522D", colorLight: "#FAF0E8" },
];


const CAT_COLORS = {
  "Coffee Spot": { bg: "#2C1810", accent: "#C8956C", light: "#F5EDE6" },
  "Restaurant":  { bg: "#1A2C1A", accent: "#7CB87C", light: "#E8F2E8" },
  "Bar":         { bg: "#1A1A2C", accent: "#7C7CC8", light: "#E8E8F5" },
  "Sports":      { bg: "#1A2828", accent: "#5CA8A8", light: "#E0F0F0" },
  "Culture":     { bg: "#2C2210", accent: "#C8A855", light: "#F5F0E0" },
  "Park":        { bg: "#162616", accent: "#5CB85C", light: "#E0F0E0" },
  "Other":       { bg: "#201E1A", accent: "#A09080", light: "#F0EDE8" },
};
const getCatColor = (cat) => CAT_COLORS[cat] || CAT_COLORS["Other"];
const SPOT_CATS = ["Restaurant", "Coffee Spot", "Bar", "Sports", "Culture", "Park", "Other"];
const EVENT_TYPES = ["Sports", "Social", "Food", "Culture"];
const AREAS = ["Kirchberg", "Grund", "City Centre", "Bonnevoie", "Limpertsberg", "Gasperich", "Mullerthal", "Clausen", "Belair", "Other"];
const EMOJI_LIST = ["☕","🍽️","🍺","🍷","🥐","🍕","🍣","🥗","🧃","🧁","🏃","⚽","🏊","🧘","🚴","🎾","🏋️","🥊","⛰️","🌲","🎵","🎭","🎨","📚","🎮","🎲","🎬","🖼️","🎪","🎠","🌿","🌸","🌞","🌙","⭐","🔥","💚","🎉","🎊","✨","📍","🗺️","🏛️","🏰","🌉","🌆","🎡","🎢","🛶","🏕️"];

const MOOD_QUESTIONS = [
  { id: "mood", question: "What are you in the mood for?", options: ["☕ Coffee", "🍽️ Food", "🍺 Drinks", "🏃 Activity", "🎵 Culture"] },
  { id: "who", question: "Who are you going with?", options: ["🙋 Solo", "👫 With a friend", "👥 Group", "💑 Date"] },
  { id: "time", question: "How much time do you have?", options: ["⚡ 30 min", "🕐 A few hours", "☀️ Full day"] },
  { id: "vibe", question: "What vibe?", options: ["😌 Chill", "💪 Active", "🎉 Social", "🔍 Hidden gem"] },
  { id: "familiar", question: "New adventure or somewhere familiar?", options: ["🎲 Surprise me", "🏠 Somewhere I know"] },
];

function scoreSpotsForMood(spots, answers) {
  return spots.map(spot => {
    let score = 0;
    const mood = answers.mood || "";
    const vibe = answers.vibe || "";
    const time = answers.time || "";
    const familiar = answers.familiar || "";
    if (mood.includes("Coffee") && spot.category === "Coffee Spot") score += 3;
    if (mood.includes("Food") && spot.category === "Restaurant") score += 3;
    if (mood.includes("Drinks") && spot.category === "Bar") score += 3;
    if (mood.includes("Activity") && spot.category === "Sports") score += 3;
    if (mood.includes("Culture") && spot.category === "Culture") score += 3;
    if (vibe.includes("Chill") && (spot.tags?.includes("Cosy") || spot.category === "Coffee Spot")) score += 2;
    if (vibe.includes("Active") && spot.category === "Sports") score += 2;
    if (vibe.includes("Social") && spot.tags?.includes("Expat")) score += 2;
    if (vibe.includes("Hidden gem") && spot.saves < 80) score += 2;
    if (time.includes("30 min") && spot.category === "Coffee Spot") score += 1;
    if (time.includes("Full day") && spot.tags?.includes("Hiking")) score += 2;
    if (familiar.includes("Surprise me") && !spot.pick) score += 1;
    if (familiar.includes("somewhere I know") && spot.pick) score += 1;
    if (spot.pick) score += 1;
    return { ...spot, score };
  }).sort((a, b) => b.score - a.score);
}

// Firebase collections
const spotsCol = collection(db, "spots");
const eventsCol = collection(db, "events");
const pendingEventsCol = collection(db, "pendingEvents");
const feedbackCol = collection(db, "feedback");
function parseDate(str) {
  if (!str) return null;
  const [d, m, y] = str.split("/");
  if (!d || !m || !y) return null;
  return new Date(y + "-" + m + "-" + d);
}
function isPast(dateStr) {
  const d = parseDate(dateStr);
  if (!d) return false;
  const today = new Date(); today.setHours(0,0,0,0);
  return d < today;
}

const inp = { width: "100%", background: "#F7F5F0", border: "1.5px solid #E2DDD5", borderRadius: 10, padding: "9px 12px", fontSize: 13, fontFamily: "system-ui", outline: "none", boxSizing: "border-box", color: "#1A2818" };
const lbl = { fontSize: 12, fontWeight: 600, color: "#6B7E67", marginBottom: 4, display: "block" };
const errSty = { fontSize: 11, color: "#A0522D", marginTop: 4 };

function Avatar({ letter, color, size = 32 }) {
  return <div style={{ width: size, height: size, borderRadius: "50%", background: color + "18", border: "1.5px solid " + color + "44", display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.38, fontWeight: 700, color, fontFamily: "system-ui", flexShrink: 0 }}>{letter}</div>;
}
function Pill({ children, active, onClick }) {
  return <button onClick={onClick} style={{ background: active ? C.accent : C.surface, color: active ? C.bg : C.textMuted, border: "1.5px solid " + (active ? C.accent : C.border), borderRadius: 999, padding: "7px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.15s", fontFamily: "system-ui" }}>{children}</button>;
}
function Tag({ children }) {
  return <span style={{ background: C.tag, color: C.textMuted, fontSize: 11, fontWeight: 500, padding: "3px 9px", borderRadius: 999, fontFamily: "system-ui" }}>{children}</span>;
}
function BottomNav({ tab, setTab }) {
  return (
    <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: C.surface, borderTop: "1px solid " + C.border, display: "flex", padding: "8px 0 18px", boxShadow: "0 -4px 20px rgba(0,0,0,0.06)" }}>
      {[{ id: "explore", icon: "🏠", label: "Home" }, { id: "events", icon: "📅", label: "Events" }, { id: "spots", icon: "📍", label: "Spots" }, { id: "profile", icon: "👤", label: "Profile" }].map(item => (
        <button key={item.id} onClick={() => setTab(item.id)} style={{ flex: 1, background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 2, padding: "4px 0" }}>
          <div style={{ width: 36, height: 28, borderRadius: 10, background: tab === item.id ? C.accentLight : "transparent", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>{item.icon}</div>
          <span style={{ fontSize: 10, fontWeight: tab === item.id ? 700 : 500, color: tab === item.id ? C.accent : C.textLight, fontFamily: "system-ui" }}>{item.label}</span>
        </button>
      ))}
    </div>
  );
}

function EmojiPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <button type="button" onClick={() => setOpen(!open)} style={{ ...inp, cursor: "pointer", fontSize: 20, padding: "6px 12px", display: "flex", alignItems: "center", gap: 8 }}>
        <span>{value || "Pick emoji"}</span>
        <span style={{ fontSize: 11, color: C.textMuted, marginLeft: "auto" }}>▼</span>
      </button>
      {open && (
        <div style={{ position: "absolute", top: "110%", left: 0, zIndex: 200, background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: 12, boxShadow: "0 8px 32px rgba(0,0,0,0.15)", display: "grid", gridTemplateColumns: "repeat(10,1fr)", gap: 4, width: 280 }}>
          {EMOJI_LIST.map(e => (
            <button key={e} type="button" onClick={() => { onChange(e); setOpen(false); }} style={{ background: value === e ? C.accentLight : "none", border: "none", borderRadius: 8, padding: "6px", fontSize: 18, cursor: "pointer" }}>{e}</button>
          ))}
        </div>
      )}
    </div>
  );
}

function SpotDetail({ spot, onBack, userProfile, onSaveToggle }) {
  const saved = userProfile?.savedSpots?.includes(spot.id) || false;
  const handleSave = async () => {
    if (!userProfile) return;
    const ref = doc(db, "users", userProfile.id);
    const spotRef = doc(db, "spots", spot.id);
    if (saved) {
      await updateDoc(ref, { savedSpots: arrayRemove(spot.id) });
      await updateDoc(spotRef, { saves: Math.max(0, (spot.saves || 0) - 1) });
    } else {
      await updateDoc(ref, { savedSpots: arrayUnion(spot.id) });
      await updateDoc(spotRef, { saves: (spot.saves || 0) + 1 });
    }
    if (onSaveToggle) onSaveToggle();
  };
  const cc = getCatColor(spot.category);
  return (
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80, background: C.bg }}>
      {/* Hero */}
      <div style={{ background: cc.bg, height: 220, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
        <span style={{ fontSize: 88, filter: "drop-shadow(0 8px 24px rgba(0,0,0,0.4))" }}>{spot.emoji}</span>
        <button onClick={onBack} style={{ position: "absolute", top: 20, left: 20, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(8px)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 999, padding: "7px 14px", fontSize: 13, fontWeight: 600, color: "#fff", cursor: "pointer", fontFamily: "'DM Sans', system-ui", display: "flex", alignItems: "center", gap: 6 }}>← Back</button>
        {spot.pick && <div style={{ position: "absolute", top: 20, right: 20, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(8px)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 999, padding: "5px 12px", fontSize: 10, fontWeight: 700, color: "#fff", letterSpacing: "0.06em" }}>★ MOSAIQ PICK</div>}
      </div>
      {/* Title bar */}
      <div style={{ padding: "20px 20px 16px", borderBottom: "1px solid " + C.border }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: cc.accent, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 6 }}>{spot.category} · {spot.area}</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: C.text, fontFamily: "'DM Serif Display', serif", letterSpacing: "-0.5px", lineHeight: 1.1 }}>{spot.name}</div>
      </div>
      <div style={{ padding: "20px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
          <div style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "12px 14px" }}>
            <div style={{ fontSize: 11, color: C.textMuted, marginBottom: 3 }}>⭐ Rating</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.accent }}>{spot.rating}</div>
          </div>
          <div style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "12px 14px" }}>
            <div style={{ fontSize: 11, color: C.textMuted, marginBottom: 3 }}>♥ Saves</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.accent }}>{spot.saves}</div>
          </div>
        </div>
        {spot.description && <div style={{ marginBottom: 20 }}><div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 8 }}>About this spot</div><div style={{ fontSize: 14, color: C.textMuted, lineHeight: 1.6 }}>{spot.description}</div></div>}
        {spot.address && <div style={{ background: C.accentLight, border: "1.5px solid " + C.accentSoft, borderRadius: 14, padding: "14px 16px", marginBottom: 20, display: "flex", gap: 10 }}>
          <span style={{ fontSize: 18 }}>🗺️</span>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: C.textMuted, marginBottom: 3, textTransform: "uppercase", letterSpacing: "0.05em" }}>Address</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: C.accent }}>{spot.address}</div>
            <button onClick={() => window.open("https://www.google.com/maps/search/" + encodeURIComponent(spot.address), "_blank")} style={{ background: "none", border: "none", color: C.blue, fontSize: 12, fontWeight: 600, cursor: "pointer", padding: "4px 0 0", fontFamily: "system-ui" }}>Open in Maps →</button>
          </div>
        </div>}
        {spot.tags?.length > 0 && <div style={{ marginBottom: 20 }}><div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 10 }}>Tags</div><div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>{spot.tags.map(tag => <Tag key={tag}>{tag}</Tag>)}</div></div>}
        <button onClick={handleSave} style={{ width: "100%", background: saved ? C.accentLight : C.accent, color: saved ? C.accent : C.bg, border: "1.5px solid " + (saved ? C.accentSoft : C.accent), borderRadius: 16, padding: "16px", fontSize: 16, fontWeight: 800, cursor: "pointer", fontFamily: "system-ui", transition: "all 0.15s" }}>
          {saved ? "♥ Saved to your list" : "♡ Save this spot"}
        </button>
      </div>
    </div>
  );
}

function EventDetail({ event, onBack, joined, onToggleJoin, userProfile, onEdit, onCancel }) {
  const isJoined = joined.includes(event.id);
  const spotsLeft = event.max - event.joined;
  const pct = Math.min(100, (event.joined / event.max) * 100);
  const isFull = event.joined >= event.max;
  const isCreator = userProfile && event.createdBy === userProfile.id;
  return (
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
      <div style={{ background: "linear-gradient(160deg, " + event.colorLight + " 0%, " + C.bg + " 100%)", padding: "20px 20px 24px", borderBottom: "1px solid " + C.border }}>
        <button onClick={onBack} style={{ background: C.surface, border: "1px solid " + C.border, borderRadius: 999, padding: "7px 14px", fontSize: 13, fontWeight: 600, color: C.text, cursor: "pointer", fontFamily: "system-ui", marginBottom: 20, display: "flex", alignItems: "center", gap: 6 }}>← Back</button>
        <div style={{ display: "flex", gap: 16, alignItems: "flex-start" }}>
          <div style={{ width: 64, height: 64, borderRadius: 18, background: event.colorLight, border: "2px solid " + event.color + "33", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 32, flexShrink: 0 }}>{event.emoji}</div>
          <div style={{ flex: 1 }}><Tag>{event.type}</Tag><div style={{ fontSize: 22, fontWeight: 800, color: C.text, marginTop: 6 }}>{event.title}</div></div>
        </div>
      </div>
      <div style={{ padding: "20px 20px 0" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
          {[{ icon: "📅", label: "Date", val: event.date }, { icon: "⏰", label: "Time", val: event.time }, { icon: "📍", label: "Area", val: event.area }, { icon: "⏱️", label: "Duration", val: event.duration || "TBC" }].map(item => (
            <div key={item.label} style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "12px 14px" }}>
              <div style={{ fontSize: 11, color: C.textMuted, marginBottom: 3 }}>{item.icon} {item.label}</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: C.text }}>{item.val}</div>
            </div>
          ))}
        </div>
        {event.meetingPoint && <div style={{ background: C.accentLight, border: "1.5px solid " + C.accentSoft, borderRadius: 14, padding: "14px 16px", marginBottom: 20, display: "flex", gap: 10 }}>
          <span style={{ fontSize: 18 }}>🗺️</span><div><div style={{ fontSize: 11, fontWeight: 600, color: C.textMuted, marginBottom: 3, textTransform: "uppercase", letterSpacing: "0.05em" }}>Meeting point</div><div style={{ fontSize: 14, fontWeight: 600, color: C.accent }}>{event.meetingPoint}</div></div>
        </div>}
        {event.description && <div style={{ marginBottom: 20 }}><div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 8 }}>About this event</div><div style={{ fontSize: 14, color: C.textMuted, lineHeight: 1.6 }}>{event.description}</div></div>}
        <div style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "14px 16px", marginBottom: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: C.text }}>{event.joined} going · {spotsLeft} spot{spotsLeft !== 1 ? "s" : ""} left</div>
            <span style={{ fontSize: 11, fontWeight: 700, color: spotsLeft <= 3 ? C.coral : C.accentMid, background: spotsLeft <= 3 ? C.coralLight : C.accentLight, padding: "3px 9px", borderRadius: 999 }}>{spotsLeft <= 3 ? "Almost full!" : event.max + " max"}</span>
          </div>
          <div style={{ height: 6, background: C.cardAlt, borderRadius: 99, overflow: "hidden" }}><div style={{ height: "100%", width: pct + "%", background: event.color, borderRadius: 99 }} /></div>
        </div>
        {event.host && <div style={{ display: "flex", alignItems: "center", gap: 12, background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "14px 16px", marginBottom: 20 }}>
          <Avatar letter={event.avatar} color={event.color} size={40} />
          <div><div style={{ fontSize: 11, color: C.textMuted, marginBottom: 2 }}>Hosted by</div><div style={{ fontSize: 15, fontWeight: 700, color: C.text }}>{event.host}</div></div>
        </div>}
      </div>
      <div style={{ padding: "0 20px 20px" }}>
        {event.paymentLink && <div style={{ background: C.yellowLight, border: "1.5px solid " + C.yellow + "44", borderRadius: 14, padding: "12px 16px", marginBottom: 12, display: "flex", gap: 10, alignItems: "center" }}>
          <span style={{ fontSize: 16 }}>💳</span>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: C.yellow, marginBottom: 2 }}>PAYMENT / BOOKING REQUIRED</div>
            <button onClick={() => window.open(event.paymentLink, "_blank")} style={{ background: "none", border: "none", color: C.blue, fontSize: 13, fontWeight: 600, cursor: "pointer", padding: 0, fontFamily: "system-ui" }}>Book your spot →</button>
          </div>
        </div>}
        {isFull && !isJoined ? (
          <div style={{ width: "100%", background: C.cardAlt, color: C.textMuted, border: "1.5px solid " + C.border, borderRadius: 16, padding: "16px", fontSize: 16, fontWeight: 700, textAlign: "center", fontFamily: "system-ui" }}>This event is full</div>
        ) : (
          <button onClick={() => onToggleJoin(event.id)} style={{ width: "100%", background: isJoined ? C.accentLight : C.accent, color: isJoined ? C.accent : C.bg, border: "1.5px solid " + (isJoined ? C.accentSoft : C.accent), borderRadius: 16, padding: "16px", fontSize: 16, fontWeight: 800, cursor: "pointer", fontFamily: "system-ui", transition: "all 0.15s" }}>
            {isJoined ? "✓ You're going! Tap to leave" : "Join this event →"}
          </button>
        )}
        {isCreator && (
          <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
            <button onClick={() => onEdit && onEdit(event)} style={{ flex: 1, background: C.accentLight, color: C.accent, border: "1.5px solid " + C.accentSoft, borderRadius: 12, padding: "11px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "system-ui" }}>Edit event</button>
            <button onClick={() => onCancel && onCancel(event)} style={{ flex: 1, background: "#FEF2F2", color: "#DC2626", border: "1.5px solid #FECACA", borderRadius: 12, padding: "11px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "system-ui" }}>Cancel event</button>
          </div>
        )}
      </div>
    </div>
  );
}

function MoodDiscovery({ spots, onClose }) {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [resultIdx, setResultIdx] = useState(0);
  const [done, setDone] = useState(false);
  const [openSpot, setOpenSpot] = useState(null);
  const ranked = done ? scoreSpotsForMood(spots, answers) : [];
  const handleAnswer = (qid, val) => {
    const na = { ...answers, [qid]: val };
    setAnswers(na);
    if (step < MOOD_QUESTIONS.length - 1) setStep(step + 1);
    else setDone(true);
  };
  if (openSpot) return <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}><SpotDetail spot={openSpot} onBack={() => setOpenSpot(null)} /></div>;
  if (done && ranked.length > 0) {
    const spot = ranked[resultIdx];
    const hasMore = resultIdx < ranked.length - 1;
    return (
      <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
        <div style={{ padding: "20px 20px 0" }}>
          <button onClick={onClose} style={{ background: "none", border: "none", color: C.accentMid, fontSize: 14, fontWeight: 600, cursor: "pointer", padding: 0, marginBottom: 16 }}>← Back</button>
          <div style={{ fontSize: 13, color: C.textMuted, marginBottom: 4 }}>{resultIdx === 0 ? "✨ Perfect match for you" : "Match " + (resultIdx + 1) + " of " + ranked.length}</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: C.text, letterSpacing: "-0.5px", marginBottom: 20 }}>{resultIdx === 0 ? "We found your spot." : "How about this one?"}</div>
          <div style={{ background: C.surface, border: "2px solid " + C.accentSoft, borderRadius: 20, overflow: "hidden", boxShadow: "0 8px 32px " + C.accent + "22", marginBottom: 16 }}>
            <div style={{ background: C.accentLight, padding: "28px 24px", display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{ width: 72, height: 72, borderRadius: 20, background: C.surface, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 36 }}>{spot.emoji}</div>
              <div>
                <div style={{ display: "flex", gap: 8, marginBottom: 6 }}><Tag>{spot.category}</Tag>{spot.pick && <span style={{ background: C.accent, color: C.bg, fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 999 }}>★ Pick</span>}</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: C.text }}>{spot.name}</div>
                <div style={{ fontSize: 13, color: C.textMuted, marginTop: 2 }}>📍 {spot.area}</div>
              </div>
            </div>
            {spot.description && <div style={{ padding: "16px 20px", borderTop: "1px solid " + C.border }}><div style={{ fontSize: 14, color: C.textMuted, lineHeight: 1.6 }}>{spot.description}</div></div>}
            {spot.address && <div style={{ padding: "12px 20px", borderTop: "1px solid " + C.border, display: "flex", gap: 8 }}><span>🗺️</span><span style={{ fontSize: 13, color: C.textMuted }}>{spot.address}</span></div>}
          </div>
          <button onClick={() => setOpenSpot(spot)} style={{ width: "100%", background: C.accent, color: C.bg, border: "none", borderRadius: 14, padding: "15px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "system-ui", marginBottom: 10 }}>This is the one! →</button>
          {hasMore && <button onClick={() => setResultIdx(resultIdx + 1)} style={{ width: "100%", background: C.surface, color: C.textMuted, border: "1.5px solid " + C.border, borderRadius: 14, padding: "15px", fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "system-ui" }}>Not feeling it, show me another →</button>}
          {!hasMore && <div style={{ textAlign: "center", padding: "12px", fontSize: 13, color: C.textMuted }}>That's all our matches! Try different answers.</div>}
          <button onClick={() => { setDone(false); setStep(0); setAnswers({}); setResultIdx(0); }} style={{ width: "100%", background: "none", color: C.textMuted, border: "none", padding: "12px", fontSize: 13, cursor: "pointer", fontFamily: "system-ui", marginTop: 4 }}>Start over</button>
        </div>
      </div>
    );
  }
  const q = MOOD_QUESTIONS[step];
  const progress = (step / MOOD_QUESTIONS.length) * 100;
  return (
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
      <div style={{ padding: "20px 20px 0" }}>
        <button onClick={onClose} style={{ background: "none", border: "none", color: C.accentMid, fontSize: 14, fontWeight: 600, cursor: "pointer", padding: 0, marginBottom: 20 }}>← Back</button>
        <div style={{ height: 4, background: C.border, borderRadius: 99, marginBottom: 24, overflow: "hidden" }}><div style={{ height: "100%", width: progress + "%", background: C.accent, borderRadius: 99, transition: "width 0.3s" }} /></div>
        <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 8 }}>Question {step + 1} of {MOOD_QUESTIONS.length}</div>
        <div style={{ fontSize: 22, fontWeight: 800, color: C.text, letterSpacing: "-0.4px", marginBottom: 24, lineHeight: 1.3 }}>{q.question}</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {q.options.map(opt => (
            <button key={opt} onClick={() => handleAnswer(q.id, opt)} style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "16px 20px", fontSize: 15, fontWeight: 600, color: C.text, cursor: "pointer", fontFamily: "system-ui", textAlign: "left", transition: "all 0.15s" }}>{opt}</button>
          ))}
        </div>
      </div>
    </div>
  );
}


function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
}





function ExploreTab({ spots, events, userProfile, setTab }) {
  const [openEvent, setOpenEvent] = useState(null);
  const [openSpot, setOpenSpot] = useState(null);
  const [showMood, setShowMood] = useState(false);
  const [localJoined, setLocalJoined] = useState(userProfile?.joinedEvents || []);
  const picks = spots.filter(s => s.pick);
  const upcomingEvents = events.filter(e => !isPast(e.date) && (e.status === "published" || !e.status)).slice(0, 3);
  const joinedIds = localJoined;
  const toggleJoin = async (eventId) => {
    if (!userProfile) return;
    const event = events.find(e => e.id === eventId);
    if (!event) return;
    const isJoined = localJoined.includes(eventId);
    const newJoined = isJoined ? localJoined.filter(x => x !== eventId) : [...localJoined, eventId];
    setLocalJoined(newJoined);
    await updateDoc(doc(db, "users", userProfile.id), { joinedEvents: newJoined });
    await updateDoc(doc(db, "events", eventId), { joined: isJoined ? Math.max(0, event.joined - 1) : event.joined + 1 });
  };

  if (showMood) return <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}><MoodDiscovery spots={spots} onClose={() => setShowMood(false)} /></div>;
  if (openEvent) return <EventDetail event={openEvent} onBack={() => setOpenEvent(null)} joined={joinedIds} onToggleJoin={toggleJoin} userProfile={userProfile} />;
  if (openSpot) return <SpotDetail spot={openSpot} onBack={() => setOpenSpot(null)} userProfile={userProfile} />;

  return (
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
      <div style={{ padding: "20px 20px 0" }}>

        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div>
            <div style={{ fontSize: 13, color: C.textMuted, marginBottom: 2 }}>{getGreeting()} 👋</div>
            <div style={{ fontSize: 26, fontWeight: 800, color: C.text, letterSpacing: "-0.5px", fontFamily: "'DM Serif Display', serif" }}>Luxembourg City</div>
          </div>
          <div onClick={() => setTab("profile")} style={{ width: 42, height: 42, borderRadius: "50%", background: C.accentLight, border: "2px solid " + C.accentSoft, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, cursor: "pointer" }}>{userProfile?.avatar || "😊"}</div>
        </div>

        {/* Mood button — prominent */}
        <button onClick={() => setShowMood(true)} style={{ width: "100%", background: "linear-gradient(135deg, " + C.accent + " 0%, " + C.accentMid + " 100%)", border: "none", borderRadius: 18, padding: "18px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer", fontFamily: "system-ui", marginBottom: 24 }}>
          <div style={{ textAlign: "left" }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.bg, marginBottom: 3 }}>✨ Not sure what to do?</div>
            <div style={{ fontSize: 12, color: C.accentSoft }}>Answer 5 questions, we find your perfect spot</div>
          </div>
          <span style={{ fontSize: 22, color: C.accentSoft }}>→</span>
        </button>
      </div>

      {/* Mosaiq Picks — editorial cards */}
      {picks.length > 0 && (
        <div style={{ marginBottom: 24 }}>
          <div style={{ padding: "0 20px 14px", display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 11, fontWeight: 700, color: C.accentMid, textTransform: "uppercase", letterSpacing: "0.12em" }}>Mosaiq Picks</span>
            <div style={{ flex: 1, height: 1, background: C.border }} />
          </div>
          <div style={{ padding: "0 20px", display: "flex", flexDirection: "column", gap: 14 }}>
            {picks.map(spot => (
              <SpotCard key={spot.id} spot={spot} onOpen={setOpenSpot} isSaved={(userProfile?.savedSpots||[]).includes(spot.id)} onSaveToggle={async (s) => {
                if (!userProfile) return;
                const isSaved = (userProfile?.savedSpots||[]).includes(s.id);
                const ref = doc(db,"users",userProfile.id); const sRef = doc(db,"spots",s.id);
                if (isSaved) { await updateDoc(ref,{savedSpots:arrayRemove(s.id)}); await updateDoc(sRef,{saves:Math.max(0,(s.saves||0)-1)}); }
                else { await updateDoc(ref,{savedSpots:arrayUnion(s.id)}); await updateDoc(sRef,{saves:(s.saves||0)+1}); }
              }} />
            ))}
          </div>
        </div>
      )}



      {/* Upcoming events — only if they exist */}
      {upcomingEvents.length > 0 && (
        <div>
          <div style={{ padding: "0 20px 10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>Happening soon</span>
            <span style={{ fontSize: 11, color: C.textMuted }}>{upcomingEvents.length} events</span>
          </div>
          <div style={{ padding: "0 20px", display: "flex", flexDirection: "column", gap: 10 }}>
            {upcomingEvents.map(event => {
              const isJoined = joinedIds.includes(event.id); const spotsLeft = event.max - event.joined;
              return (
                <div key={event.id} style={{ background: C.surface, borderRadius: 18, border: "1.5px solid " + C.border, overflow: "hidden" }}>
                  <div style={{ height: 3, background: event.color }} />
                  <div style={{ padding: 14 }}>
                    <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                      <div style={{ width: 44, height: 44, borderRadius: 13, background: event.colorLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>{event.emoji}</div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: C.text, marginBottom: 3 }}>{event.title}</div>
                        <div style={{ fontSize: 12, color: C.textMuted }}>{event.area} · {event.date}{event.time && " at " + event.time}</div>
                      </div>
                      <button onClick={() => toggleJoin(event.id)} style={{ background: isJoined ? C.accentLight : C.accent, color: isJoined ? C.accent : C.bg, border: "1.5px solid " + (isJoined ? C.accentSoft : C.accent), borderRadius: 10, padding: "7px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}>{isJoined ? "✓ In" : "Join"}</button>
                    </div>
                    <div style={{ marginTop: 10, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <span style={{ fontSize: 11, color: spotsLeft <= 3 ? C.coral : C.textMuted, fontWeight: spotsLeft <= 3 ? 700 : 400 }}>{spotsLeft <= 3 ? spotsLeft + " spots left!" : event.joined + "/" + event.max + " going"}</span>
                      <button onClick={() => setOpenEvent(event)} style={{ background: "none", border: "none", color: C.accentMid, fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0 }}>Details →</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

function EventCreateForm({ userProfile, onBack }) {
  const fi = { width:"100%", background:C.surface, border:"1.5px solid "+C.border, borderRadius:12, padding:"11px 14px", color:C.text, fontSize:14, fontFamily:"system-ui", outline:"none", boxSizing:"border-box" };
  const [form, setForm] = useState({ title:"", type:"Sports", area:"", areaOther:"", date:"", time:"", max:"12", host: userProfile?.name || "", description:"", meetingPoint:"", duration:"", emoji:"📅", paymentLink:"" });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [saving, setSaving] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const col = EVENT_COLORS[0];

  const validate = () => {
    const e = {};
    if (!form.title.trim()) e.title = "Title is required";
    if (!form.area) e.area = "Area is required";
    if (!form.date) e.date = "Date is required";
    if (form.date && !/^\d{2}\/\d{2}\/\d{4}$/.test(form.date)) e.date = "Use format dd/mm/yyyy";
    if (!form.time.trim()) e.time = "Time is required";
    return e;
  };

  const handleSubmit = async () => {
    const e = validate(); if (Object.keys(e).length > 0) { setErrors(e); return; }
    setSaving(true);
    try {
      await addDoc(pendingEventsCol, {
        title: form.title.trim(),
        type: form.type,
        area: form.area === "Other" ? form.areaOther : form.area,
        date: form.date,
        time: form.time,
        max: parseInt(form.max) || 12,
        host: form.host || userProfile?.name || "Anonymous",
        avatar: (form.host || userProfile?.name || "?")[0].toUpperCase(),
        emoji: form.emoji,
        color: col.color,
        colorLight: col.colorLight,
        description: form.description,
        meetingPoint: form.meetingPoint,
        duration: form.duration,
        paymentLink: form.paymentLink,
        createdBy: userProfile?.id || "",
        createdAt: new Date().toISOString(),
        status: "pending",
        joined: 0,
      });
      setSubmitted(true);
    } catch(err) {
      console.error("Submission error:", err);
      setErrors({ title: "Failed to submit: " + err.message });
      setSaving(false);
    }
  };

  if (submitted) return (
    <div style={{ flex:1, overflowY:"auto", padding:"40px 24px", textAlign:"center" }}>
      <div style={{ fontSize:56, marginBottom:16 }}>🎉</div>
      <div style={{ fontSize:22, fontWeight:800, color:C.text, marginBottom:8 }}>Event submitted!</div>
      <div style={{ fontSize:14, color:C.textMuted, lineHeight:1.6, marginBottom:24 }}>We will review it shortly — usually live within a few hours.</div>
      <div style={{ background:C.accentLight, borderRadius:14, padding:16, marginBottom:24 }}>
        <div style={{ fontSize:13, color:C.accentMid, fontWeight:600 }}>All events are reviewed before going live 🙌</div>
      </div>
      <button onClick={onBack} style={{ background:C.accent, color:C.bg, border:"none", borderRadius:14, padding:"13px 32px", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"system-ui" }}>Back to Events</button>
    </div>
  );

  return (
    <div style={{ flex:1, overflowY:"auto", padding:"20px 20px 80px" }}>
      <button onClick={onBack} style={{ background:"none", border:"none", color:C.accentMid, fontSize:14, fontWeight:600, cursor:"pointer", marginBottom:20, padding:0 }}>← Back</button>
      <div style={{ fontSize:22, fontWeight:800, color:C.text, marginBottom:4 }}>Create an event</div>
      <div style={{ fontSize:14, color:C.textMuted, marginBottom:24 }}>Organise something for the community</div>
      <div style={{ display:"flex", flexDirection:"column", gap:16 }}>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Event name *</div>
          <input value={form.title} onChange={e=>set("title",e.target.value)} placeholder="e.g. Sunday morning run" style={{...fi, border:"1.5px solid "+(errors.title?C.coral:C.border)}} />
          {errors.title && <div style={{ fontSize:11, color:C.coral, marginTop:4 }}>{errors.title}</div>}
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Emoji</div>
            <EmojiPicker value={form.emoji} onChange={v=>set("emoji",v)} />
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Category</div>
            <select value={form.type} onChange={e=>set("type",e.target.value)} style={fi}>{EVENT_TYPES.map(t=><option key={t}>{t}</option>)}</select>
          </div>
        </div>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Area *</div>
          <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
            {AREAS.map(area=><button key={area} onClick={()=>set("area",area)} style={{ background:form.area===area?C.accentLight:C.surface, color:form.area===area?C.accent:C.textMuted, border:"1.5px solid "+(form.area===area?C.accentSoft:C.border), borderRadius:10, padding:"7px 12px", fontSize:12, cursor:"pointer", fontFamily:"system-ui" }}>{area}</button>)}
          </div>
          {form.area==="Other" && <input value={form.areaOther} onChange={e=>set("areaOther",e.target.value)} placeholder="Describe the location..." style={{...fi, marginTop:8}} />}
          {errors.area && <div style={{ fontSize:11, color:C.coral, marginTop:4 }}>{errors.area}</div>}
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Date * (dd/mm/yyyy)</div>
            <input value={form.date} onChange={e=>set("date",e.target.value)} placeholder="15/04/2026" style={{...fi, border:"1.5px solid "+(errors.date?C.coral:C.border)}} />
            {errors.date && <div style={{ fontSize:11, color:C.coral, marginTop:4 }}>{errors.date}</div>}
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Time *</div>
            <input value={form.time} onChange={e=>set("time",e.target.value)} placeholder="09:00" style={{...fi, border:"1.5px solid "+(errors.time?C.coral:C.border)}} />
            {errors.time && <div style={{ fontSize:11, color:C.coral, marginTop:4 }}>{errors.time}</div>}
          </div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Max people</div>
            <input value={form.max} onChange={e=>set("max",e.target.value)} placeholder="12" style={fi} />
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Duration</div>
            <input value={form.duration} onChange={e=>set("duration",e.target.value)} placeholder="~1h 30min" style={fi} />
          </div>
        </div>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Meeting point</div>
          <input value={form.meetingPoint} onChange={e=>set("meetingPoint",e.target.value)} placeholder="e.g. Pescatore Park entrance" style={fi} />
        </div>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:8 }}>Description</div>
          <textarea value={form.description} onChange={e=>set("description",e.target.value)} placeholder="Tell people what to expect..." style={{...fi, height:80, resize:"vertical"}} />
        </div>
        <div>
          <div style={{ fontSize:13, fontWeight:600, color:C.text, marginBottom:4 }}>Payment / booking link <span style={{ fontWeight:400, color:C.textMuted }}>(optional)</span></div>
          <div style={{ fontSize:11, color:C.textMuted, marginBottom:8 }}>Add if people need to pay or book elsewhere</div>
          <input value={form.paymentLink} onChange={e=>set("paymentLink",e.target.value)} placeholder="https://..." style={fi} />
        </div>
        <button onClick={handleSubmit} disabled={saving} style={{ background:C.accent, color:C.bg, border:"none", borderRadius:14, padding:"14px", fontSize:15, fontWeight:700, cursor:saving?"not-allowed":"pointer", fontFamily:"system-ui", opacity:saving?0.7:1, marginTop:8 }}>{saving?"Submitting...":"Submit for review →"}</button>
      </div>
    </div>
  );
}

function EventsTab({ events, userProfile }) {
  const [showCreate, setShowCreate] = useState(false);
  const [openEvent, setOpenEvent] = useState(null);
  const [localJoined, setLocalJoined] = useState(userProfile?.joinedEvents || []);
  const joinedIds = localJoined;
  const toggleJoin = async (eventId) => {
    if (!userProfile) return;
    const event = events.find(e => e.id === eventId);
    if (!event) return;
    const isJoined = localJoined.includes(eventId);
    const newJoined = isJoined ? localJoined.filter(x => x !== eventId) : [...localJoined, eventId];
    setLocalJoined(newJoined);
    await updateDoc(doc(db, "users", userProfile.id), { joinedEvents: newJoined });
    await updateDoc(doc(db, "events", eventId), { joined: isJoined ? Math.max(0, event.joined - 1) : event.joined + 1 });
  };
  const upcoming = events.filter(e => !isPast(e.date) && (e.status === "published" || !e.status));
  const sorted = [...upcoming].sort((a, b) => { const da = parseDate(a.date); const db = parseDate(b.date); if (!da && !db) return 0; if (!da) return 1; if (!db) return -1; return da - db; });
  if (openEvent) return <EventDetail event={openEvent} onBack={() => setOpenEvent(null)} joined={joinedIds} onToggleJoin={toggleJoin} userProfile={userProfile} />;
  if (showCreate) return <EventCreateForm userProfile={userProfile} onBack={() => { setShowCreate(false); }} />;
  return (
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
      <div style={{ padding: "20px 20px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: 22, fontWeight: 800, color: C.text }}>Events</div>
        <button onClick={() => setShowCreate(true)} style={{ background: C.accent, color: C.bg, border: "none", borderRadius: 12, padding: "9px 16px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>+ Create</button>
      </div>
      <div style={{ padding: "0 20px", display: "flex", flexDirection: "column", gap: 10 }}>
        {sorted.map(event => {
          const pct = (event.joined / event.max) * 100;
          return (
            <div key={event.id} style={{ background: C.surface, borderRadius: 18, border: "1.5px solid " + C.border, overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.05)" }}>
              <div style={{ height: 3, background: event.color }} />
              <div style={{ padding: 16 }}>
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <div style={{ width: 48, height: 48, borderRadius: 14, background: event.colorLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>{event.emoji}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 4 }}>{event.title}</div>
                    <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 10 }}>{event.area} · {event.date} at {event.time}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div style={{ flex: 1, height: 4, background: C.cardAlt, borderRadius: 99, overflow: "hidden" }}><div style={{ height: "100%", width: pct + "%", background: event.color, borderRadius: 99 }} /></div>
                      <span style={{ fontSize: 11, color: C.textMuted }}>{event.joined}/{event.max}</span>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 12, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}><Avatar letter={event.avatar} color={event.color} size={24} /><span style={{ fontSize: 12, color: C.textMuted }}>by {event.host}</span></div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button onClick={() => setOpenEvent(event)} style={{ background: C.surface, color: C.accentMid, border: "1.5px solid " + C.border, borderRadius: 10, padding: "7px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>Open</button>
                    <button onClick={() => toggleJoin(event.id)} style={{ background: joinedIds.includes(event.id) ? C.accentLight : event.colorLight, color: joinedIds.includes(event.id) ? C.accent : event.color, border: "1.5px solid " + (joinedIds.includes(event.id) ? C.accentSoft : event.color + "44"), borderRadius: 10, padding: "7px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{joinedIds.includes(event.id) ? "✓ In" : "Join →"}</button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function SpotCard({ spot, onOpen, isSaved, onSaveToggle }) {
  const cc = getCatColor(spot.category);
  return (
    <div onClick={() => onOpen(spot)} style={{ borderRadius: 20, overflow: "hidden", cursor: "pointer", background: C.surface, boxShadow: "0 4px 24px rgba(0,0,0,0.08)", position: "relative" }}>
      {/* Colour backdrop with emoji */}
      <div style={{ background: cc.bg, height: 140, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
        <span style={{ fontSize: 64, filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.3))" }}>{spot.emoji}</span>
        {spot.pick && (
          <div style={{ position: "absolute", top: 12, left: 12, background: "rgba(255,255,255,0.15)", backdropFilter: "blur(8px)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 999, padding: "4px 10px", fontSize: 10, fontWeight: 700, color: "#fff", letterSpacing: "0.05em" }}>★ MOSAIQ PICK</div>
        )}
        <button onClick={async e => { e.stopPropagation(); onSaveToggle && onSaveToggle(spot); }} style={{ position: "absolute", top: 12, right: 12, background: isSaved ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.15)", backdropFilter: "blur(8px)", border: "1px solid rgba(255,255,255,0.2)", borderRadius: "50%", width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 16, color: isSaved ? "#E53E3E" : "#fff" }}>{isSaved ? "♥" : "♡"}</button>
      </div>
      {/* Card body */}
      <div style={{ padding: "14px 16px 16px" }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 4 }}>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: cc.accent, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 4 }}>{spot.category} · {spot.area}</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.text, lineHeight: 1.15, fontFamily: "'DM Serif Display', serif", letterSpacing: "-0.3px" }}>{spot.name}</div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 3, flexShrink: 0, marginLeft: 8, marginTop: 4 }}>
            <span style={{ fontSize: 11 }}>⭐</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: C.text }}>{spot.rating}</span>
          </div>
        </div>
        {spot.description && <div style={{ fontSize: 13, color: C.textMuted, lineHeight: 1.5, marginTop: 6 }}>{spot.description.length > 72 ? spot.description.slice(0, 72) + "…" : spot.description}</div>}
        {spot.tags?.length > 0 && (
          <div style={{ display: "flex", gap: 6, marginTop: 10, flexWrap: "wrap" }}>
            {spot.tags.slice(0,3).map(tag => <span key={tag} style={{ background: cc.light, color: cc.bg, fontSize: 10, fontWeight: 600, padding: "3px 8px", borderRadius: 999 }}>{tag}</span>)}
          </div>
        )}
      </div>
    </div>
  );
}

function SpotsTab({ spots, userProfile }) {
  const [filter, setFilter] = useState("All");
  const [openSpot, setOpenSpot] = useState(null);
  const savedIds = userProfile?.savedSpots || [];

  const handleSaveToggle = async (spot) => {
    if (!userProfile) return;
    const isSaved = savedIds.includes(spot.id);
    const ref = doc(db, "users", userProfile.id);
    const sRef = doc(db, "spots", spot.id);
    if (isSaved) {
      await updateDoc(ref, { savedSpots: arrayRemove(spot.id) });
      await updateDoc(sRef, { saves: Math.max(0, (spot.saves || 0) - 1) });
    } else {
      await updateDoc(ref, { savedSpots: arrayUnion(spot.id) });
      await updateDoc(sRef, { saves: (spot.saves || 0) + 1 });
    }
  };

  const picks = spots.filter(s => s.pick);
  const others = spots.filter(s => !s.pick);
  const CATS = ["All", "Coffee Spot", "Restaurant", "Bar", "Sports", "Culture"];
  const filtered = filter === "All" ? others : spots.filter(s => s.category === filter && !s.pick);
  const filteredPicks = filter === "All" ? picks : picks.filter(s => s.category === filter);

  if (openSpot) return <SpotDetail spot={openSpot} onBack={() => setOpenSpot(null)} userProfile={userProfile} />;

  return (
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80, background: C.bg }}>
      {/* Header */}
      <div style={{ padding: "24px 20px 8px" }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: C.textMuted, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 6 }}>Luxembourg City</div>
        <div style={{ fontSize: 32, fontWeight: 800, color: C.text, fontFamily: "'DM Serif Display', serif", letterSpacing: "-0.5px", lineHeight: 1.1 }}>Our favourite<br />spots in the city.</div>
      </div>

      {/* Filter pills */}
      <div style={{ display: "flex", gap: 8, padding: "16px 20px", overflowX: "auto" }}>
        {CATS.map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{ background: filter === f ? C.text : C.surface, color: filter === f ? C.bg : C.textMuted, border: "1.5px solid " + (filter === f ? C.text : C.border), borderRadius: 999, padding: "7px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", transition: "all 0.15s", fontFamily: "'DM Sans', system-ui" }}>{f}</button>
        ))}
      </div>

      <div style={{ padding: "0 20px" }}>
        {/* Mosaiq Picks — featured */}
        {filteredPicks.length > 0 && (
          <div style={{ marginBottom: 28 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: C.accentMid, textTransform: "uppercase", letterSpacing: "0.12em" }}>Mosaiq Picks</div>
              <div style={{ flex: 1, height: 1, background: C.border }} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              {filteredPicks.map(spot => (
                <SpotCard key={spot.id} spot={spot} onOpen={setOpenSpot} isSaved={savedIds.includes(spot.id)} onSaveToggle={handleSaveToggle} />
              ))}
            </div>
          </div>
        )}

        {/* All other spots */}
        {filtered.length > 0 && (
          <div style={{ marginBottom: 20 }}>
            {filter === "All" && filteredPicks.length > 0 && (
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: C.textMuted, textTransform: "uppercase", letterSpacing: "0.12em" }}>More spots</div>
                <div style={{ flex: 1, height: 1, background: C.border }} />
              </div>
            )}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              {filtered.map(spot => {
                const cc = getCatColor(spot.category);
                const isSaved = savedIds.includes(spot.id);
                return (
                  <div key={spot.id} onClick={() => setOpenSpot(spot)} style={{ borderRadius: 16, overflow: "hidden", cursor: "pointer", background: C.surface, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
                    <div style={{ background: cc.bg, height: 88, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                      <span style={{ fontSize: 36 }}>{spot.emoji}</span>
                      <button onClick={async e => { e.stopPropagation(); handleSaveToggle(spot); }} style={{ position: "absolute", top: 6, right: 6, background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "50%", width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 12, color: isSaved ? "#E53E3E" : "rgba(255,255,255,0.8)" }}>{isSaved ? "♥" : "♡"}</button>
                    </div>
                    <div style={{ padding: "10px 12px 12px" }}>
                      <div style={{ fontSize: 9, fontWeight: 700, color: cc.accent, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 3 }}>{spot.category}</div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: C.text, lineHeight: 1.2, fontFamily: "'DM Serif Display', serif" }}>{spot.name}</div>
                      <div style={{ fontSize: 11, color: C.textMuted, marginTop: 3 }}>{spot.area} · ⭐ {spot.rating}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {filtered.length === 0 && filteredPicks.length === 0 && (
          <div style={{ textAlign: "center", padding: "40px 20px" }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>🔍</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.text, marginBottom: 6 }}>No spots in this category yet</div>
            <div style={{ fontSize: 13, color: C.textMuted }}>We're adding more spots soon.</div>
          </div>
        )}
      </div>
    </div>
  );
}

function ProfileTab({ spots, events, userProfile, onSignOut, setTab }) {
  const savedSpotIds = userProfile?.savedSpots || [];
  const joinedEventIds = userProfile?.joinedEvents || [];
  const savedSpots = spots.filter(s => savedSpotIds.includes(s.id));
  const upcomingJoined = events.filter(e => joinedEventIds.includes(e.id) && !isPast(e.date)).sort((a,b) => { const da=parseDate(a.date); const db=parseDate(b.date); if(!da&&!db)return 0;if(!da)return 1;if(!db)return -1;return da-db; });
  const pastEvents = events.filter(e => joinedEventIds.includes(e.id) && isPast(e.date)).sort((a,b) => { const da=parseDate(a.date); const db=parseDate(b.date); if(!da&&!db)return 0;if(!da)return 1;if(!db)return -1;return db-da; });
  const [showPast, setShowPast] = useState(false);
  const [editingProfile, setEditingProfile] = useState(false);
  const [editForm, setEditForm] = useState({ name: userProfile?.name||"", username: userProfile?.username||"", avatar: userProfile?.avatar||"😊", interests: userProfile?.interests||[] });
  const [savingEdit, setSavingEdit] = useState(false);

  const saveProfile = async () => {
    if (!editForm.name.trim() || !editForm.username.trim()) return;
    setSavingEdit(true);
    await updateDoc(doc(db, "users", userProfile.id), { name: editForm.name.trim(), username: editForm.username.trim().toLowerCase(), avatar: editForm.avatar, interests: editForm.interests });
    setSavingEdit(false); setEditingProfile(false);
  };

  if (editingProfile) return (
    <div style={{ flex:1, overflowY:"auto", padding:"20px 20px 80px" }}>
      <button onClick={() => setEditingProfile(false)} style={{ background:"none", border:"none", color:C.accentMid, fontSize:14, fontWeight:600, cursor:"pointer", marginBottom:20, padding:0 }}>← Back</button>
      <div style={{ fontSize:20, fontWeight:800, color:C.text, marginBottom:24 }}>Edit profile</div>
      <div style={{ display:"flex", justifyContent:"center", marginBottom:20 }}>
        <div style={{ width:80, height:80, borderRadius:"50%", background:C.accentLight, border:"2px solid "+C.accentSoft, display:"flex", alignItems:"center", justifyContent:"center", fontSize:40 }}>{editForm.avatar}</div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(6,1fr)", gap:8, marginBottom:20 }}>
        {["😊","😎","🤩","🥳","🏃","⚽","🧘","🎵","🍕","☕","🌿","🔥","🎨","📚","🎮","🌍","🏔️","🚴","🎾","🍺","✨","💚","🎉","🦁","🐺","🦊","🐻","🦋","🌸","⭐"].map(e=>(
          <button key={e} onClick={()=>setEditForm(f=>({...f,avatar:e}))} style={{ background:editForm.avatar===e?C.accentLight:"none", border:"1.5px solid "+(editForm.avatar===e?C.accentSoft:C.border), borderRadius:10, padding:"8px", fontSize:20, cursor:"pointer" }}>{e}</button>
        ))}
      </div>
      <div style={{ marginBottom:14 }}>
        <label style={lbl}>Name</label>
        <input value={editForm.name} onChange={e=>setEditForm(f=>({...f,name:e.target.value}))} style={{ ...{width:"100%",background:C.bg,border:"1.5px solid "+C.border,borderRadius:10,padding:"9px 12px",fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box",color:C.text} }} />
      </div>
      <div style={{ marginBottom:20 }}>
        <label style={lbl}>Username</label>
        <div style={{ position:"relative" }}>
          <span style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", color:C.textMuted, fontSize:14 }}>@</span>
          <input value={editForm.username} onChange={e=>setEditForm(f=>({...f,username:e.target.value.replace(/\s/g,"").toLowerCase()}))} style={{ ...{width:"100%",background:C.bg,border:"1.5px solid "+C.border,borderRadius:10,padding:"9px 12px 9px 28px",fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box",color:C.text} }} />
        </div>
      </div>
      <div style={{ marginBottom:24 }}>
        <label style={lbl}>Interests</label>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
          {["🏃 Sports","🍽️ Food & Drink","🎵 Culture","🎉 Social","🌿 Nature","🎨 Arts","📚 Learning","🎮 Gaming"].map(i=>(
            <button key={i} onClick={()=>setEditForm(f=>({...f,interests:f.interests.includes(i)?f.interests.filter(x=>x!==i):[...f.interests,i]}))} style={{ background:editForm.interests.includes(i)?C.accentLight:C.surface, border:"1.5px solid "+(editForm.interests.includes(i)?C.accentSoft:C.border), borderRadius:12, padding:"10px", fontSize:13, fontWeight:600, color:editForm.interests.includes(i)?C.accent:C.textMuted, cursor:"pointer", fontFamily:"system-ui", textAlign:"left" }}>{i}</button>
          ))}
        </div>
      </div>
      <button onClick={saveProfile} disabled={savingEdit} style={{ width:"100%", background:C.accent, color:C.bg, border:"none", borderRadius:14, padding:"14px", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"system-ui" }}>{savingEdit?"Saving...":"Save changes"}</button>
    </div>
  );
  return (
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
      <div style={{ background: C.surface, padding: "20px 20px 24px", borderBottom: "1px solid " + C.border }}>
        <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 20 }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: C.accentLight, border: "2px solid " + C.accentSoft, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 36 }}>{userProfile?.avatar || "😊"}</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.text }}>{userProfile?.name || "User"}</div>
            <div style={{ fontSize: 13, color: C.textMuted, marginTop: 2 }}>@{userProfile?.username || "user"}</div>
            <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>{(userProfile?.interests || []).slice(0,3).map(i => <Tag key={i}>{i}</Tag>)}</div>
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            <button onClick={() => setEditingProfile(true)} style={{ background:C.accentLight, border:"1.5px solid "+C.accentSoft, borderRadius:10, padding:"6px 12px", fontSize:12, color:C.accent, cursor:"pointer", fontFamily:"system-ui" }}>Edit</button>
            <button onClick={onSignOut} style={{ background:"none", border:"1.5px solid "+C.border, borderRadius:10, padding:"6px 12px", fontSize:12, color:C.textMuted, cursor:"pointer", fontFamily:"system-ui" }}>Sign out</button>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
          {[{ val: String(joinedEventIds.length), label: "Joined" }, { val: String(savedSpotIds.length), label: "Saved" }, { val: String(pastEvents.length), label: "Attended" }].map(stat => (
            <div key={stat.label} style={{ background: C.accentLight, borderRadius: 14, padding: "14px 10px", textAlign: "center", border: "1px solid " + C.accentSoft }}>
              <div style={{ fontSize: 22, fontWeight: 800, color: C.accent }}>{stat.val}</div>
              <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 12 }}>Saved spots</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 24 }}>
          {savedSpots.length === 0 ? (
            <div style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "20px", textAlign: "center" }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>📍</div>
              <div style={{ fontSize: 13, color: C.textMuted }}>No saved spots yet</div>
              <button onClick={() => setTab("spots")} style={{ background: "none", border: "none", color: C.accentMid, fontSize: 13, fontWeight: 600, cursor: "pointer", marginTop: 4, fontFamily: "system-ui" }}>Browse spots →</button>
            </div>
          ) : savedSpots.map(spot => (
            <div key={spot.id} style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "12px 14px", display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 20 }}>{spot.emoji}</span>
              <div style={{ flex: 1 }}><div style={{ fontSize: 14, fontWeight: 600, color: C.text }}>{spot.name}</div><div style={{ fontSize: 12, color: C.textMuted }}>{spot.category} · {spot.area}</div></div>
              <span style={{ color: C.accentMid, fontSize: 16 }}>♥</span>
            </div>
          ))}
        </div>
        {upcomingJoined.length > 0 && (
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 12 }}>Upcoming events</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {upcomingJoined.map(event => (
                <div key={event.id} style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, overflow: "hidden" }}>
                  <div style={{ height: 3, background: event.color }} />
                  <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ width: 40, height: 40, borderRadius: 12, background: event.colorLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>{event.emoji}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: C.text }}>{event.title}</div>
                      <div style={{ fontSize: 12, color: C.textMuted, marginTop: 2 }}>{event.area} · {event.date} at {event.time}</div>
                    </div>
                    <span style={{ fontSize: 11, background: C.accentLight, color: C.accentMid, padding: "3px 10px", borderRadius: 999, fontWeight: 600 }}>Going ✓</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {pastEvents.length > 0 && (
          <div>
            <button onClick={() => setShowPast(!showPast)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", background: "none", border: "none", padding: "0 0 12px", cursor: "pointer", fontFamily: "system-ui" }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>Past events ({pastEvents.length})</span>
              <span style={{ fontSize: 13, color: C.textMuted }}>{showPast ? "▲ Hide" : "▼ Show"}</span>
            </button>
            {showPast && (
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {pastEvents.map(event => (
                  <div key={event.id} style={{ background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, overflow: "hidden", opacity: 0.75 }}>
                    <div style={{ height: 3, background: event.color }} />
                    <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 12 }}>
                      <div style={{ width: 40, height: 40, borderRadius: 12, background: event.colorLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, flexShrink: 0 }}>{event.emoji}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: C.text }}>{event.title}</div>
                        <div style={{ fontSize: 12, color: C.textMuted, marginTop: 2 }}>{event.area} · {event.date}</div>
                      </div>
                      <span style={{ fontSize: 11, background: C.cardAlt, color: C.textMuted, padding: "3px 10px", borderRadius: 999, fontWeight: 600 }}>Past</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

const AVATAR_EMOJIS = ["😊","😎","🤩","🥳","🏃","⚽","🧘","🎵","🍕","☕","🌿","🔥","🎨","📚","🎮","🌍","🏔️","🚴","🎾","🍺","✨","💚","🎉","🦁","🐺","🦊","🐻","🦋","🌸","⭐"];
const INTEREST_OPTIONS = ["🏃 Sports", "🍽️ Food & Drink", "🎵 Culture", "🎉 Social", "🌿 Nature", "🎨 Arts", "📚 Learning", "🎮 Gaming"];

function LoginScreen() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleGoogle = async () => {
    setLoading(true); setError("");
    try { await signInWithPopup(auth, googleProvider); }
    catch { setError("Login failed. Please try again."); setLoading(false); }
  };
  return (
    <div style={{ minHeight: "100vh", background: C.accent, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "system-ui", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 340, textAlign: "center" }}>
        <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 20 }}>
          {["#F7F5F0","#2C6B7A","#B8860B","#A0522D"].map((c,i) => <div key={i} style={{ width: 12, height: 12, borderRadius: 4, background: c }} />)}
        </div>
        <div style={{ fontSize: 44, fontWeight: 800, color: C.bg, letterSpacing: "-1px", marginBottom: 8 }}>mosaiq</div>
        <div style={{ fontSize: 15, color: C.accentSoft, marginBottom: 48, lineHeight: 1.6 }}>Discover Luxembourg through people who actually live here.</div>
        <button onClick={handleGoogle} disabled={loading} style={{ width: "100%", background: C.bg, border: "none", borderRadius: 16, padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "center", gap: 12, cursor: loading ? "not-allowed" : "pointer", fontFamily: "system-ui", opacity: loading ? 0.7 : 1 }}>
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>{loading ? "Signing in..." : "Continue with Google"}</span>
        </button>
        {error && <div style={{ fontSize: 13, color: C.coralLight, marginTop: 12 }}>{error}</div>}

      </div>
    </div>
  );
}

function OnboardingFlow({ user, onComplete }) {
  const [step, setStep] = useState(0);
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [avatar, setAvatar] = useState("😊");
  const [interests, setInterests] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const toggleInterest = (i) => setInterests(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]);

  const handleFinish = async () => {
    if (!name.trim()) { setError("Please enter your name"); return; }
    if (!username.trim()) { setError("Please enter a username"); return; }
    setSaving(true);
    try {
      await setDoc(doc(db, "users", user.uid), {
        name: name.trim(),
        username: username.trim().toLowerCase().replace(/\s/g, ""),
        avatar,
        interests,
        joinedEvents: [],
        savedSpots: [],
        createdAt: new Date().toISOString(),
      });
      onComplete();
    } catch { setError("Something went wrong. Please try again."); setSaving(false); }
  };

  const steps = [
    // Step 0: Name
    <div key="name">
      <div style={{ fontSize: 26, fontWeight: 800, color: C.text, letterSpacing: "-0.5px", marginBottom: 8 }}>What's your name?</div>
      <div style={{ fontSize: 14, color: C.textMuted, marginBottom: 28 }}>This is how you'll appear on Mosaiq.</div>
      <input value={name} onChange={e => { setName(e.target.value); setError(""); }} placeholder="e.g. Pedro" style={{ width: "100%", background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "14px 16px", fontSize: 16, fontFamily: "system-ui", outline: "none", boxSizing: "border-box", color: C.text }} />
      {error && <div style={{ fontSize: 12, color: C.coral, marginTop: 8 }}>{error}</div>}
      <button onClick={() => { if (!name.trim()) { setError("Please enter your name"); return; } setError(""); setStep(1); }} style={{ width: "100%", background: C.accent, color: C.bg, border: "none", borderRadius: 14, padding: "14px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "system-ui", marginTop: 16 }}>Continue →</button>
    </div>,

    // Step 1: Username
    <div key="username">
      <div style={{ fontSize: 26, fontWeight: 800, color: C.text, letterSpacing: "-0.5px", marginBottom: 8 }}>Pick a username</div>
      <div style={{ fontSize: 14, color: C.textMuted, marginBottom: 28 }}>Your unique handle on Mosaiq.</div>
      <div style={{ position: "relative" }}>
        <span style={{ position: "absolute", left: 16, top: "50%", transform: "translateY(-50%)", fontSize: 16, color: C.textMuted }}>@</span>
        <input value={username} onChange={e => { setUsername(e.target.value.replace(/\s/g, "").toLowerCase()); setError(""); }} placeholder="pedrofc" style={{ width: "100%", background: C.surface, border: "1.5px solid " + C.border, borderRadius: 14, padding: "14px 16px 14px 32px", fontSize: 16, fontFamily: "system-ui", outline: "none", boxSizing: "border-box", color: C.text }} />
      </div>
      {error && <div style={{ fontSize: 12, color: C.coral, marginTop: 8 }}>{error}</div>}
      <button onClick={() => { if (!username.trim()) { setError("Please enter a username"); return; } setError(""); setStep(2); }} style={{ width: "100%", background: C.accent, color: C.bg, border: "none", borderRadius: 14, padding: "14px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "system-ui", marginTop: 16 }}>Continue →</button>
      <button onClick={() => setStep(0)} style={{ width: "100%", background: "none", border: "none", color: C.textMuted, fontSize: 14, cursor: "pointer", padding: "10px", fontFamily: "system-ui" }}>← Back</button>
    </div>,

    // Step 2: Avatar
    <div key="avatar">
      <div style={{ fontSize: 26, fontWeight: 800, color: C.text, letterSpacing: "-0.5px", marginBottom: 8 }}>Pick your avatar</div>
      <div style={{ fontSize: 14, color: C.textMuted, marginBottom: 28 }}>Choose an emoji that represents you.</div>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
        <div style={{ width: 80, height: 80, borderRadius: "50%", background: C.accentLight, border: "2px solid " + C.accentSoft, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40 }}>{avatar}</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 8, marginBottom: 20 }}>
        {AVATAR_EMOJIS.map(e => (
          <button key={e} onClick={() => setAvatar(e)} style={{ background: avatar === e ? C.accentLight : C.surface, border: "1.5px solid " + (avatar === e ? C.accentSoft : C.border), borderRadius: 12, padding: "10px", fontSize: 22, cursor: "pointer", transition: "all 0.1s" }}>{e}</button>
        ))}
      </div>
      <button onClick={() => setStep(3)} style={{ width: "100%", background: C.accent, color: C.bg, border: "none", borderRadius: 14, padding: "14px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "system-ui" }}>Continue →</button>
      <button onClick={() => setStep(1)} style={{ width: "100%", background: "none", border: "none", color: C.textMuted, fontSize: 14, cursor: "pointer", padding: "10px", fontFamily: "system-ui" }}>← Back</button>
    </div>,

    // Step 3: Interests
    <div key="interests">
      <div style={{ fontSize: 26, fontWeight: 800, color: C.text, letterSpacing: "-0.5px", marginBottom: 8 }}>What are you into?</div>
      <div style={{ fontSize: 14, color: C.textMuted, marginBottom: 24 }}>We'll personalise your experience. Pick as many as you like.</div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 24 }}>
        {INTEREST_OPTIONS.map(i => (
          <button key={i} onClick={() => toggleInterest(i)} style={{ background: interests.includes(i) ? C.accentLight : C.surface, border: "1.5px solid " + (interests.includes(i) ? C.accentSoft : C.border), borderRadius: 14, padding: "14px 12px", fontSize: 14, fontWeight: 600, color: interests.includes(i) ? C.accent : C.textMuted, cursor: "pointer", fontFamily: "system-ui", textAlign: "left", transition: "all 0.15s" }}>{i}</button>
        ))}
      </div>
      {error && <div style={{ fontSize: 12, color: C.coral, marginBottom: 8 }}>{error}</div>}
      <button onClick={handleFinish} disabled={saving} style={{ width: "100%", background: C.accent, color: C.bg, border: "none", borderRadius: 14, padding: "14px", fontSize: 15, fontWeight: 700, cursor: saving ? "not-allowed" : "pointer", fontFamily: "system-ui", opacity: saving ? 0.7 : 1 }}>{saving ? "Setting up..." : "Let's go →"}</button>
      <button onClick={() => setStep(2)} style={{ width: "100%", background: "none", border: "none", color: C.textMuted, fontSize: 14, cursor: "pointer", padding: "10px", fontFamily: "system-ui" }}>← Back</button>
    </div>,
  ];

  const progress = ((step) / 4) * 100;

  return (
    <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "system-ui", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 360 }}>
        <div style={{ display: "flex", gap: 4, marginBottom: 8, justifyContent: "center" }}>
          {["#F7F5F0","#2C6B7A","#B8860B","#A0522D"].map((c,i) => <div key={i} style={{ width: 8, height: 8, borderRadius: 2, background: c }} />)}
        </div>
        <div style={{ fontSize: 16, fontWeight: 800, color: C.accent, textAlign: "center", marginBottom: 32 }}>mosaiq</div>
        <div style={{ height: 4, background: C.border, borderRadius: 99, marginBottom: 32, overflow: "hidden" }}>
          <div style={{ height: "100%", width: progress + "%", background: C.accent, borderRadius: 99, transition: "width 0.3s" }} />
        </div>
        {steps[step]}
      </div>
    </div>
  );
}

function FeedbackButton({ userProfile }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [sent, setSent] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!msg.trim()) return;
    setSaving(true);
    await addDoc(feedbackCol, { message: msg.trim(), userName: userProfile?.name || "Anonymous", userId: userProfile?.id || "", createdAt: new Date().toISOString() });
    setSent(true); setSaving(false);
  };

  if (!open) return (
    <button onClick={() => setOpen(true)} style={{ position:"fixed", bottom:90, right:20, background:C.accent, color:C.bg, border:"none", borderRadius:999, padding:"10px 16px", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"system-ui", boxShadow:"0 4px 16px "+C.accent+"44", zIndex:50 }}>💬 Feedback</button>
  );

  return (
    <div style={{ position:"fixed", bottom:90, right:20, background:C.surface, border:"1.5px solid "+C.border, borderRadius:20, padding:20, width:300, boxShadow:"0 8px 32px rgba(0,0,0,0.15)", zIndex:50, fontFamily:"system-ui" }}>
      {sent ? (
        <div style={{ textAlign:"center", padding:"10px 0" }}>
          <div style={{ fontSize:32, marginBottom:8 }}>🙏</div>
          <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:4 }}>Thanks for your feedback!</div>
          <div style={{ fontSize:12, color:C.textMuted, marginBottom:16 }}>We read every message.</div>
          <button onClick={() => { setOpen(false); setSent(false); setMsg(""); }} style={{ background:C.accent, color:C.bg, border:"none", borderRadius:10, padding:"8px 20px", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"system-ui" }}>Close</button>
        </div>
      ) : (
        <>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
            <div style={{ fontSize:14, fontWeight:700, color:C.text }}>Share feedback</div>
            <button onClick={() => setOpen(false)} style={{ background:"none", border:"none", fontSize:18, cursor:"pointer", color:C.textMuted }}>×</button>
          </div>
          <textarea value={msg} onChange={e=>setMsg(e.target.value)} placeholder="Something broken? A spot we're missing? Tell us anything..." style={{ width:"100%", background:C.bg, border:"1.5px solid "+C.border, borderRadius:10, padding:"10px 12px", fontSize:13, fontFamily:"system-ui", outline:"none", resize:"none", height:90, boxSizing:"border-box", color:C.text }} />
          <button onClick={submit} disabled={saving||!msg.trim()} style={{ width:"100%", background:C.accent, color:C.bg, border:"none", borderRadius:10, padding:"10px", fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"system-ui", marginTop:10, opacity:(!msg.trim()||saving)?0.6:1 }}>{saving?"Sending...":"Send feedback"}</button>
        </>
      )}
    </div>
  );
}

function AdminLogin({ onLogin }) {
  const [pw, setPw] = useState(""); const [err, setErr] = useState(false);
  const attempt = () => { if (pw === ADMIN_PASSWORD) onLogin(); else { setErr(true); setPw(""); } };
  return (
    <div style={{ minHeight: "100vh", background: C.accent, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "system-ui" }}>
      <div style={{ background: C.surface, borderRadius: 24, padding: 40, width: 360, boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ display: "flex", gap: 4, marginBottom: 16 }}>{["#F7F5F0","#2C6B7A","#B8860B","#A0522D"].map((c,i)=><div key={i} style={{ width:10, height:10, borderRadius:3, background:c }}/>)}</div>
        <div style={{ fontSize: 28, fontWeight: 800, color: C.accent, marginBottom: 4 }}>mosaiq</div>
        <div style={{ fontSize: 14, color: C.textMuted, marginBottom: 32 }}>Admin Dashboard</div>
        <label style={lbl}>Password</label>
        <input type="password" value={pw} onChange={e=>{setPw(e.target.value);setErr(false);}} onKeyDown={e=>e.key==="Enter"&&attempt()} placeholder="Enter admin password" style={{...inp, marginBottom:8, border:"1.5px solid "+(err?C.coral:C.border)}}/>
        {err && <div style={errSty}>Incorrect password.</div>}
        <button onClick={attempt} style={{ width:"100%", background:C.accent, color:C.bg, border:"none", borderRadius:12, padding:"13px", fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"system-ui", marginTop:12 }}>Enter →</button>
      </div>
    </div>
  );
}

function SpotPreview({ spot }) {
  const tags = typeof spot.tags === "string" ? spot.tags.split(",").map(t=>t.trim()).filter(Boolean) : (spot.tags||[]);
  return (
    <div style={{ background: C.surface, borderRadius: 18, border: "1.5px solid " + C.border, padding: 16 }}>
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
        <div style={{ width: 52, height: 52, borderRadius: 14, background: C.accentLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0 }}>{spot.emoji || "📍"}</div>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 3 }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: C.text }}>{spot.name || "Spot name"}</span>
            {spot.pick && <span style={{ background: C.accentLight, color: C.accentMid, fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 999 }}>★ Pick</span>}
          </div>
          <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 6 }}>{spot.category || "Category"} · {spot.area || "Area"} · ⭐ {spot.rating || "4.5"}</div>
          {spot.description && <div style={{ fontSize: 12, color: C.textLight, marginBottom: 6 }}>{spot.description}</div>}
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{tags.map((tag,i) => <Tag key={i}>{tag}</Tag>)}</div>
        </div>
      </div>
    </div>
  );
}

function EventPreview({ event }) {
  const col = EVENT_COLORS[event.colorIndex || 0];
  return (
    <div style={{ background: C.surface, borderRadius: 18, border: "1.5px solid " + C.border, overflow: "hidden" }}>
      <div style={{ height: 3, background: col.color }} />
      <div style={{ padding: 16 }}>
        <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
          <div style={{ width: 48, height: 48, borderRadius: 14, background: col.colorLight, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>{event.emoji || "📅"}</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: C.text, marginBottom: 4 }}>{event.title || "Event title"}</div>
            <div style={{ fontSize: 12, color: C.textMuted, marginBottom: 8 }}>{event.area || "Area"} · {event.date || "Date"} at {event.time || "Time"}</div>
            <div style={{ height: 4, background: C.cardAlt, borderRadius: 99 }} />
          </div>
        </div>
        <div style={{ marginTop: 12, paddingTop: 10, borderTop: "1px solid " + C.border, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 12, color: C.textMuted }}>by {event.host || "Host name"}</span>
          <div style={{ background: col.color, color: "#fff", borderRadius: 10, padding: "6px 14px", fontSize: 12, fontWeight: 700 }}>Join →</div>
        </div>
      </div>
    </div>
  );
}

function EditModal({ item, type, onSave, onClose }) {
  const [form, setForm] = useState({...item, tags: Array.isArray(item.tags) ? item.tags.join(", ") : (item.tags||"")});
  const cIdx = EVENT_COLORS.findIndex(c => c.color === item.color);
  const [colorIdx, setColorIdx] = useState(cIdx >= 0 ? cIdx : 0);
  const [errors, setErrors] = useState({});
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const validate = () => {
    const e = {};
    if (!form.name && !form.title) e.name = "Name is required";
    if (!form.area) e.area = "Area is required";
    if (type === "event" && !form.date) e.date = "Date is required";
    if (type === "event" && form.date && !/^\d{2}\/\d{2}\/\d{4}$/.test(form.date)) e.date = "Use format dd/mm/yyyy";
    return e;
  };
  const handleSave = () => {
    const e = validate(); if (Object.keys(e).length > 0) { setErrors(e); return; }
    const u = {...form};
    if (type === "spot") { u.tags = form.tags.split(",").map(t=>t.trim()).filter(Boolean); u.rating = parseFloat(form.rating)||4.5; }
    else { u.max = parseInt(form.max)||10; u.avatar = form.host ? form.host[0].toUpperCase() : "?"; u.color = EVENT_COLORS[colorIdx].color; u.colorLight = EVENT_COLORS[colorIdx].colorLight; }
    onSave(u);
  };
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000, padding:20 }}>
      <div style={{ background:C.surface, borderRadius:20, padding:28, width:"100%", maxWidth:580, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div style={{ fontSize:18, fontWeight:700, color:C.text }}>Edit {type==="spot"?"Spot":"Event"}</div>
          <button onClick={onClose} style={{ background:"none", border:"none", fontSize:22, cursor:"pointer", color:C.textMuted }}>×</button>
        </div>
        {type === "spot" ? (
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <div><label style={lbl}>Name *</label><input style={{...inp, border:"1.5px solid "+(errors.name?C.coral:C.border)}} value={form.name} onChange={e=>set("name",e.target.value)}/>{errors.name&&<div style={errSty}>{errors.name}</div>}</div>
            <div><label style={lbl}>Emoji</label><EmojiPicker value={form.emoji} onChange={v=>set("emoji",v)}/></div>
            <div><label style={lbl}>Category</label><select style={inp} value={form.category} onChange={e=>set("category",e.target.value)}>{SPOT_CATS.map(c=><option key={c}>{c}</option>)}</select></div>
            <div><label style={lbl}>Area *</label><input style={{...inp, border:"1.5px solid "+(errors.area?C.coral:C.border)}} value={form.area} onChange={e=>set("area",e.target.value)}/>{errors.area&&<div style={errSty}>{errors.area}</div>}</div>
            <div><label style={lbl}>Rating</label><input style={inp} value={form.rating} onChange={e=>set("rating",e.target.value)}/></div>
            <div><label style={lbl}>Tags (comma separated)</label><input style={inp} value={form.tags} onChange={e=>set("tags",e.target.value)}/></div>
            <div style={{gridColumn:"1/-1"}}><label style={lbl}>Description</label><textarea style={{...inp,height:70,resize:"vertical"}} value={form.description||""} onChange={e=>set("description",e.target.value)}/></div>
            <div style={{gridColumn:"1/-1"}}><label style={lbl}>Address</label><input style={inp} value={form.address||""} onChange={e=>set("address",e.target.value)}/></div>
            <div style={{gridColumn:"1/-1",display:"flex",alignItems:"center",gap:10}}><input type="checkbox" id="epick" checked={form.pick} onChange={e=>set("pick",e.target.checked)}/><label htmlFor="epick" style={{fontSize:14,color:C.text,cursor:"pointer"}}>⭐ Mosaiq Pick</label></div>
          </div>
        ) : (
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <div style={{gridColumn:"1/-1"}}><label style={lbl}>Title *</label><input style={{...inp,border:"1.5px solid "+(errors.name?C.coral:C.border)}} value={form.title} onChange={e=>set("title",e.target.value)}/>{errors.name&&<div style={errSty}>{errors.name}</div>}</div>
            <div><label style={lbl}>Emoji</label><EmojiPicker value={form.emoji} onChange={v=>set("emoji",v)}/></div>
            <div><label style={lbl}>Type</label><select style={inp} value={form.type} onChange={e=>set("type",e.target.value)}>{EVENT_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
            <div><label style={lbl}>Area *</label><input style={{...inp,border:"1.5px solid "+(errors.area?C.coral:C.border)}} value={form.area} onChange={e=>set("area",e.target.value)}/>{errors.area&&<div style={errSty}>{errors.area}</div>}</div>
            <div><label style={lbl}>Date (dd/mm/yyyy) *</label><input style={{...inp,border:"1.5px solid "+(errors.date?C.coral:C.border)}} placeholder="15/03/2026" value={form.date} onChange={e=>set("date",e.target.value)}/>{errors.date&&<div style={errSty}>{errors.date}</div>}</div>
            <div><label style={lbl}>Time</label><input style={inp} placeholder="09:00" value={form.time} onChange={e=>set("time",e.target.value)}/></div>
            <div><label style={lbl}>Max People</label><input style={inp} value={form.max} onChange={e=>set("max",e.target.value)}/></div>
            <div><label style={lbl}>Host</label><input style={inp} value={form.host} onChange={e=>set("host",e.target.value)}/></div>
            <div style={{gridColumn:"1/-1"}}><label style={lbl}>Description</label><textarea style={{...inp,height:80,resize:"vertical"}} value={form.description||""} onChange={e=>set("description",e.target.value)}/></div>
            <div><label style={lbl}>Meeting Point</label><input style={inp} value={form.meetingPoint||""} onChange={e=>set("meetingPoint",e.target.value)}/></div>
            <div><label style={lbl}>Duration</label><input style={inp} placeholder="~1h 30min" value={form.duration||""} onChange={e=>set("duration",e.target.value)}/></div>
            <div style={{gridColumn:"1/-1"}}><label style={lbl}>Colour</label><div style={{display:"flex",gap:8}}>{EVENT_COLORS.map((c,i)=><button key={i} onClick={()=>setColorIdx(i)} style={{width:28,height:28,borderRadius:8,background:c.color,border:colorIdx===i?"3px solid "+C.text:"3px solid transparent",cursor:"pointer"}}/>)}</div></div>
          </div>
        )}
        <div style={{display:"flex",gap:10,marginTop:20}}>
          <button onClick={handleSave} style={{background:C.accent,color:C.bg,border:"none",borderRadius:10,padding:"10px 24px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>Save Changes</button>
          <button onClick={onClose} style={{background:"none",color:C.textMuted,border:"1.5px solid "+C.border,borderRadius:10,padding:"10px 20px",fontSize:14,cursor:"pointer",fontFamily:"system-ui"}}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

async function addSpotToFirestore(spot) { await addDoc(spotsCol, spot); }
async function updateSpotInFirestore(id, data) { await updateDoc(doc(db, "spots", id), data); }
async function deleteSpotFromFirestore(id) { await deleteDoc(doc(db, "spots", id)); }
async function addEventToFirestore(event) { await addDoc(eventsCol, event); }
async function updateEventInFirestore(id, data) { await updateDoc(doc(db, "events", id), data); }
async function deleteEventFromFirestore(id) { await deleteDoc(doc(db, "events", id)); }

function AdminDashboard({ spots, events, onLogout, pendingEvents, feedbackItems }) {
  const [section, setSection] = useState("spots");
  const [allUsers, setAllUsers] = useState([]);
  useEffect(() => { getDocs(collection(db,"users")).then(snap => setAllUsers(snap.docs.map(d=>({id:d.id,...d.data()})))); }, []);
  const [showAddSpot, setShowAddSpot] = useState(false);
  const [showAddEvent, setShowAddEvent] = useState(false);
  const [editItem, setEditItem] = useState(null); const [editType, setEditType] = useState(null);
  const [showPreviewSpot, setShowPreviewSpot] = useState(false);
  const [showPreviewEvent, setShowPreviewEvent] = useState(false);
  const [errors, setErrors] = useState({});
  const [dupWarn, setDupWarn] = useState("");
  const [ns, setNs] = useState({name:"",category:"Restaurant",area:"",rating:"4.5",tags:"",emoji:"📍",pick:false,description:"",address:""});
  const [ne, setNe] = useState({title:"",type:"Sports",area:"",date:"",time:"",max:"10",host:"",emoji:"📅",description:"",meetingPoint:"",duration:"",colorIndex:0});
  const upd = (setter,k,v) => setter(f=>({...f,[k]:v}));
  const checkDupSpot = (name,area) => { const d = spots.find(s=>s.name.toLowerCase()===name.toLowerCase()&&s.area.toLowerCase()===area.toLowerCase()); setDupWarn(d ? "A spot called \""+d.name+"\" in "+d.area+" already exists!" : ""); };
  const checkDupEvent = (title,date) => { const d = events.find(e=>e.title.toLowerCase()===title.toLowerCase()&&e.date===date); setDupWarn(d ? "An event called \""+d.title+"\" on "+d.date+" already exists!" : ""); };
  const validateSpot = () => { const e={}; if(!ns.name) e.name="Name is required"; if(!ns.area) e.area="Area is required"; return e; };
  const validateEvent = () => { const e={}; if(!ne.title) e.title="Title is required"; if(!ne.area) e.area="Area is required"; if(!ne.date) e.date="Date is required"; if(ne.date&&!/^\d{2}\/\d{2}\/\d{4}$/.test(ne.date)) e.date="Use format dd/mm/yyyy"; return e; };
  const addSpot = async () => {
    const e = validateSpot(); if(Object.keys(e).length>0){setErrors(e);return;}
    await addSpotToFirestore({name:ns.name,category:ns.category,area:ns.area,rating:parseFloat(ns.rating)||4.5,tags:ns.tags.split(",").map(t=>t.trim()).filter(Boolean),saves:0,pick:ns.pick,emoji:ns.emoji,description:ns.description,address:ns.address});
    setNs({name:"",category:"Restaurant",area:"",rating:"4.5",tags:"",emoji:"📍",pick:false,description:"",address:""}); setErrors({}); setDupWarn(""); setShowAddSpot(false); setShowPreviewSpot(false);
  };
  const addEvent = async () => {
    const e = validateEvent(); if(Object.keys(e).length>0){setErrors(e);return;}
    const col = EVENT_COLORS[ne.colorIndex];
    await addEventToFirestore({title:ne.title,type:ne.type,area:ne.area,date:ne.date,time:ne.time,joined:0,max:parseInt(ne.max)||10,host:ne.host,avatar:ne.host?ne.host[0].toUpperCase():"?",emoji:ne.emoji,color:col.color,colorLight:col.colorLight,description:ne.description,meetingPoint:ne.meetingPoint,duration:ne.duration});
    setNe({title:"",type:"Sports",area:"",date:"",time:"",max:"10",host:"",emoji:"📅",description:"",meetingPoint:"",duration:"",colorIndex:0}); setErrors({}); setDupWarn(""); setShowAddEvent(false); setShowPreviewEvent(false);
  };
  const delSpot = async (id) => { await deleteSpotFromFirestore(id); };
  const delEvent = async (id) => { await deleteEventFromFirestore(id); };
  const togglePick = async (id) => { const spot = spots.find(s => s.id === id); if (spot) await updateSpotInFirestore(id, { pick: !spot.pick }); };
  const saveEdit = async (updated) => {
    const { id, ...data } = updated;
    if(editType==="spot") await updateSpotInFirestore(id, data);
    else await updateEventInFirestore(id, data);
    setEditItem(null); setEditType(null);
  };
  const sortedSpots = [...spots].sort((a,b)=>a.name.localeCompare(b.name));
  const sortedEvents = [...events].sort((a,b)=>{const da=parseDate(a.date);const db=parseDate(b.date);if(!da&&!db)return 0;if(!da)return 1;if(!db)return -1;return da-db;});
  const btnStyle = {background:C.accent,color:C.bg,border:"none",borderRadius:10,padding:"10px 24px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"};
  const previewBtnStyle = {background:C.accentLight,color:C.accent,border:"1.5px solid "+C.accentSoft,borderRadius:10,padding:"10px 18px",fontSize:14,cursor:"pointer",fontFamily:"system-ui",fontWeight:600};
  const cancelBtnStyle = {background:"none",color:C.textMuted,border:"1.5px solid "+C.border,borderRadius:10,padding:"10px 20px",fontSize:14,cursor:"pointer",fontFamily:"system-ui"};
  return (
    <div style={{ minHeight:"100vh", background:"#F0EDE6", fontFamily:"system-ui" }}>
      {editItem && <EditModal item={editItem} type={editType} onSave={saveEdit} onClose={()=>{setEditItem(null);setEditType(null);}}/>}
      <div style={{ background:C.accent, padding:"16px 32px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <div style={{display:"flex",gap:4}}>{["#F7F5F0","#2C6B7A","#B8860B","#A0522D"].map((c,i)=><div key={i} style={{width:8,height:8,borderRadius:2,background:c,opacity:0.8}}/>)}</div>
          <span style={{fontSize:18,fontWeight:800,color:C.bg}}>mosaiq</span><span style={{fontSize:13,color:C.accentSoft}}>Admin</span>
        </div>
        <button onClick={onLogout} style={{background:"none",border:"1px solid "+C.accentSoft,borderRadius:8,padding:"6px 14px",fontSize:13,color:C.accentSoft,cursor:"pointer",fontFamily:"system-ui"}}>Log out</button>
      </div>
      <div style={{background:C.surface,borderBottom:"1px solid "+C.border,padding:"16px 32px",display:"flex",gap:32}}>
        {[{label:"Total Spots",val:spots.length,color:C.accent},{label:"Total Events",val:events.length,color:C.blue},{label:"Mosaiq Picks",val:spots.filter(s=>s.pick).length,color:C.yellow}].map(s=>(
          <div key={s.label}><div style={{fontSize:24,fontWeight:800,color:s.color}}>{s.val}</div><div style={{fontSize:12,color:C.textMuted}}>{s.label}</div></div>
        ))}
      </div>
      <div style={{padding:"24px 32px 0",display:"flex",gap:12,flexWrap:"wrap"}}>
        {[{id:"spots",label:"📍 Spots"},{id:"events",label:"📅 Events"},{id:"pending",label:"⏳ Pending"},{id:"feedback",label:"💬 Feedback"},{id:"analytics",label:"📊 Analytics"}].map(s=>(
          <button key={s.id} onClick={()=>setSection(s.id)} style={{background:section===s.id?C.accent:C.surface,color:section===s.id?C.bg:C.textMuted,border:"1.5px solid "+(section===s.id?C.accent:C.border),borderRadius:10,padding:"9px 20px",fontSize:14,fontWeight:600,cursor:"pointer",fontFamily:"system-ui"}}>{s.label}</button>
        ))}
      </div>
      <div style={{padding:"24px 32px"}}>
        {section==="spots" && (
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div style={{fontSize:20,fontWeight:700,color:C.text}}>Spots ({spots.length})</div>
              <button onClick={()=>{setShowAddSpot(!showAddSpot);setErrors({});setDupWarn("");setShowPreviewSpot(false);}} style={btnStyle}>+ Add Spot</button>
            </div>
            {showAddSpot && (
              <div style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:16,padding:24,marginBottom:24}}>
                <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:20}}>New Spot</div>
                {dupWarn && <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:13,color:"#DC2626"}}>⚠️ {dupWarn}</div>}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                  <div><label style={lbl}>Name *</label><input style={{...inp,border:"1.5px solid "+(errors.name?C.coral:C.border)}} placeholder="e.g. Beim Engel" value={ns.name} onChange={e=>{upd(setNs,"name",e.target.value);checkDupSpot(e.target.value,ns.area);setErrors(ev=>({...ev,name:""}))}}/>{errors.name&&<div style={errSty}>{errors.name}</div>}</div>
                  <div><label style={lbl}>Emoji</label><EmojiPicker value={ns.emoji} onChange={v=>upd(setNs,"emoji",v)}/></div>
                  <div><label style={lbl}>Category</label><select style={inp} value={ns.category} onChange={e=>upd(setNs,"category",e.target.value)}>{SPOT_CATS.map(c=><option key={c}>{c}</option>)}</select></div>
                  <div><label style={lbl}>Area *</label><input style={{...inp,border:"1.5px solid "+(errors.area?C.coral:C.border)}} placeholder="e.g. Grund" value={ns.area} onChange={e=>{upd(setNs,"area",e.target.value);checkDupSpot(ns.name,e.target.value);setErrors(ev=>({...ev,area:""}))}}/>{errors.area&&<div style={errSty}>{errors.area}</div>}</div>
                  <div><label style={lbl}>Rating</label><input style={inp} placeholder="4.5" value={ns.rating} onChange={e=>upd(setNs,"rating",e.target.value)}/></div>
                  <div><label style={lbl}>Tags (comma separated)</label><input style={inp} placeholder="Cosy, Vegan" value={ns.tags} onChange={e=>upd(setNs,"tags",e.target.value)}/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Description</label><textarea style={{...inp,height:70,resize:"vertical"}} placeholder="A short tip about this spot..." value={ns.description} onChange={e=>upd(setNs,"description",e.target.value)}/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Address</label><input style={inp} placeholder="e.g. 14 Rue de la Forêt" value={ns.address} onChange={e=>upd(setNs,"address",e.target.value)}/></div>
                  <div style={{gridColumn:"1/-1",display:"flex",alignItems:"center",gap:10}}><input type="checkbox" id="npick" checked={ns.pick} onChange={e=>upd(setNs,"pick",e.target.checked)}/><label htmlFor="npick" style={{fontSize:14,color:C.text,cursor:"pointer"}}>⭐ Mosaiq Pick</label></div>
                </div>
                {showPreviewSpot && <div style={{marginTop:20}}><div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:8}}>PREVIEW</div><SpotPreview spot={ns}/></div>}
                <div style={{display:"flex",gap:10,marginTop:20,flexWrap:"wrap"}}>
                  <button onClick={addSpot} style={btnStyle}>Save Spot</button>
                  <button onClick={()=>setShowPreviewSpot(!showPreviewSpot)} style={previewBtnStyle}>👁 Preview</button>
                  <button onClick={()=>{setShowAddSpot(false);setErrors({});setDupWarn("");setShowPreviewSpot(false);}} style={cancelBtnStyle}>Cancel</button>
                </div>
              </div>
            )}
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {sortedSpots.map(spot=>(
                <div key={spot.id} style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:"14px 18px",display:"flex",alignItems:"center",gap:14}}>
                  <div style={{width:44,height:44,borderRadius:12,background:C.accentLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>{spot.emoji}</div>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",alignItems:"center",gap:8}}><span style={{fontSize:15,fontWeight:700,color:C.text}}>{spot.name}</span>{spot.pick&&<span style={{fontSize:11,background:C.accentLight,color:C.accentMid,padding:"2px 8px",borderRadius:999,fontWeight:700}}>★ Pick</span>}</div>
                    <div style={{fontSize:12,color:C.textMuted,marginTop:2}}>{spot.category} · {spot.area} · ⭐ {spot.rating}</div>
                    {spot.tags?.length>0&&<div style={{fontSize:11,color:C.textLight,marginTop:2}}>{spot.tags.join(", ")}</div>}
                  </div>
                  <button onClick={()=>togglePick(spot.id)} style={{background:spot.pick?C.accentLight:C.bg,color:spot.pick?C.accentMid:C.textMuted,border:"1.5px solid "+(spot.pick?C.accentSoft:C.border),borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer",fontFamily:"system-ui",fontWeight:600}}>{spot.pick?"★":"☆"}</button>
                  <button onClick={()=>{setEditItem(spot);setEditType("spot");}} style={{background:C.accentLight,color:C.accent,border:"1.5px solid "+C.accentSoft,borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer",fontFamily:"system-ui",fontWeight:600}}>Edit</button>
                  <button onClick={()=>delSpot(spot.id)} style={{background:"#FEF2F2",color:"#DC2626",border:"1.5px solid #FECACA",borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer",fontFamily:"system-ui",fontWeight:600}}>Delete</button>
                </div>
              ))}
            </div>
          </div>
        )}
        {section==="events" && (
          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
              <div style={{fontSize:20,fontWeight:700,color:C.text}}>Events ({events.length})</div>
              <button onClick={()=>{setShowAddEvent(!showAddEvent);setErrors({});setDupWarn("");setShowPreviewEvent(false);}} style={btnStyle}>+ Add Event</button>
            </div>
            {showAddEvent && (
              <div style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:16,padding:24,marginBottom:24}}>
                <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:20}}>New Event</div>
                {dupWarn && <div style={{background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:13,color:"#DC2626"}}>⚠️ {dupWarn}</div>}
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Title *</label><input style={{...inp,border:"1.5px solid "+(errors.title?C.coral:C.border)}} placeholder="e.g. Sunday Morning Run" value={ne.title} onChange={e=>{upd(setNe,"title",e.target.value);checkDupEvent(e.target.value,ne.date);setErrors(ev=>({...ev,title:""}))}}/>{errors.title&&<div style={errSty}>{errors.title}</div>}</div>
                  <div><label style={lbl}>Emoji</label><EmojiPicker value={ne.emoji} onChange={v=>upd(setNe,"emoji",v)}/></div>
                  <div><label style={lbl}>Type</label><select style={inp} value={ne.type} onChange={e=>upd(setNe,"type",e.target.value)}>{EVENT_TYPES.map(t=><option key={t}>{t}</option>)}</select></div>
                  <div><label style={lbl}>Area *</label><input style={{...inp,border:"1.5px solid "+(errors.area?C.coral:C.border)}} placeholder="e.g. Kirchberg" value={ne.area} onChange={e=>{upd(setNe,"area",e.target.value);setErrors(ev=>({...ev,area:""}))}}/>{errors.area&&<div style={errSty}>{errors.area}</div>}</div>
                  <div><label style={lbl}>Date * (dd/mm/yyyy)</label><input style={{...inp,border:"1.5px solid "+(errors.date?C.coral:C.border)}} placeholder="15/03/2026" value={ne.date} onChange={e=>{upd(setNe,"date",e.target.value);checkDupEvent(ne.title,e.target.value);setErrors(ev=>({...ev,date:""}))}}/>{errors.date&&<div style={errSty}>{errors.date}</div>}</div>
                  <div><label style={lbl}>Time</label><input style={inp} placeholder="09:00" value={ne.time} onChange={e=>upd(setNe,"time",e.target.value)}/></div>
                  <div><label style={lbl}>Max People</label><input style={inp} placeholder="10" value={ne.max} onChange={e=>upd(setNe,"max",e.target.value)}/></div>
                  <div><label style={lbl}>Host</label><input style={inp} placeholder="e.g. Pedro F." value={ne.host} onChange={e=>upd(setNe,"host",e.target.value)}/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Description</label><textarea style={{...inp,height:70,resize:"vertical"}} value={ne.description} onChange={e=>upd(setNe,"description",e.target.value)}/></div>
                  <div><label style={lbl}>Meeting Point</label><input style={inp} value={ne.meetingPoint} onChange={e=>upd(setNe,"meetingPoint",e.target.value)}/></div>
                  <div><label style={lbl}>Duration</label><input style={inp} placeholder="~1h 30min" value={ne.duration} onChange={e=>upd(setNe,"duration",e.target.value)}/></div>
                  <div style={{gridColumn:"1/-1"}}><label style={lbl}>Colour</label><div style={{display:"flex",gap:8}}>{EVENT_COLORS.map((c,i)=><button key={i} onClick={()=>upd(setNe,"colorIndex",i)} style={{width:28,height:28,borderRadius:8,background:c.color,border:ne.colorIndex===i?"3px solid "+C.text:"3px solid transparent",cursor:"pointer"}}/>)}</div></div>
                </div>
                {showPreviewEvent && <div style={{marginTop:20}}><div style={{fontSize:13,fontWeight:600,color:C.textMuted,marginBottom:8}}>PREVIEW</div><EventPreview event={ne}/></div>}
                <div style={{display:"flex",gap:10,marginTop:20,flexWrap:"wrap"}}>
                  <button onClick={addEvent} style={btnStyle}>Save Event</button>
                  <button onClick={()=>setShowPreviewEvent(!showPreviewEvent)} style={previewBtnStyle}>👁 Preview</button>
                  <button onClick={()=>{setShowAddEvent(false);setErrors({});setDupWarn("");setShowPreviewEvent(false);}} style={cancelBtnStyle}>Cancel</button>
                </div>
              </div>
            )}
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {sortedEvents.map(event=>(
                <div key={event.id} style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,overflow:"hidden",display:"flex",alignItems:"center"}}>
                  <div style={{width:5,alignSelf:"stretch",background:event.color,flexShrink:0}}/>
                  <div style={{padding:"14px 18px",display:"flex",alignItems:"center",gap:14,flex:1}}>
                    <div style={{width:44,height:44,borderRadius:12,background:event.colorLight,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>{event.emoji}</div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:15,fontWeight:700,color:C.text}}>{event.title}</div>
                      <div style={{fontSize:12,color:C.textMuted,marginTop:2}}>{event.type} · {event.area} · {event.date}{event.time&&" at "+event.time}</div>
                      <div style={{fontSize:12,color:C.textLight,marginTop:2}}>{event.joined}/{event.max} joined{event.host&&" · by "+event.host}</div>
                    </div>
                    <button onClick={()=>{setEditItem(event);setEditType("event");}} style={{background:C.accentLight,color:C.accent,border:"1.5px solid "+C.accentSoft,borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer",fontFamily:"system-ui",fontWeight:600}}>Edit</button>
                    <button onClick={()=>delEvent(event.id)} style={{background:"#FEF2F2",color:"#DC2626",border:"1.5px solid #FECACA",borderRadius:8,padding:"6px 12px",fontSize:12,cursor:"pointer",fontFamily:"system-ui",fontWeight:600}}>Delete</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {section==="pending" && (
          <div>
            <div style={{fontSize:20,fontWeight:700,color:C.text,marginBottom:20}}>Pending Events ({(pendingEvents||[]).length})</div>
            {(pendingEvents||[]).length === 0 ? (
              <div style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:32,textAlign:"center"}}>
                <div style={{fontSize:32,marginBottom:8}}>✅</div>
                <div style={{fontSize:14,color:C.textMuted}}>No pending events</div>
              </div>
            ) : [...(pendingEvents||[])].sort((a,b)=>b.createdAt?.localeCompare(a.createdAt||"")).map(ev => (
              <div key={ev.id} style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:20,marginBottom:12}}>
                <div style={{marginBottom:12}}>
                  <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:4}}>{ev.emoji} {ev.title}</div>
                  <div style={{fontSize:13,color:C.textMuted}}>{ev.type} · {ev.area} · {ev.date} at {ev.time}</div>
                  <div style={{fontSize:12,color:C.textMuted,marginTop:2}}>Max: {ev.max} · Host: {ev.host}</div>
                  {ev.description && <div style={{fontSize:12,color:C.textMuted,marginTop:4,fontStyle:"italic"}}>{ev.description}</div>}
                  {ev.meetingPoint && <div style={{fontSize:12,color:C.textMuted,marginTop:2}}>📍 {ev.meetingPoint}</div>}
                  {ev.paymentLink && <div style={{fontSize:12,color:C.blue,marginTop:2}}>💳 {ev.paymentLink}</div>}
                  <div style={{fontSize:11,color:C.textLight,marginTop:4}}>Submitted {ev.createdAt ? new Date(ev.createdAt).toLocaleDateString() : ""}</div>
                </div>
                <div style={{display:"flex",gap:10}}>
                  <button onClick={async()=>{ const {id,...data}=ev; await addEventToFirestore({...data,status:"published"}); await deleteDoc(doc(db,"pendingEvents",id)); }} style={{background:C.accent,color:C.bg,border:"none",borderRadius:10,padding:"8px 20px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>✓ Approve</button>
                  <button onClick={async()=>{ await deleteDoc(doc(db,"pendingEvents",ev.id)); }} style={{background:"#FEF2F2",color:"#DC2626",border:"1.5px solid #FECACA",borderRadius:10,padding:"8px 20px",fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:"system-ui"}}>✗ Reject</button>
                </div>
              </div>
            ))}
          </div>
        )}
        {section==="feedback" && (
          <div>
            <div style={{fontSize:20,fontWeight:700,color:C.text,marginBottom:20}}>Feedback ({(feedbackItems||[]).length})</div>
            {(feedbackItems||[]).length === 0 ? (
              <div style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:32,textAlign:"center"}}>
                <div style={{fontSize:32,marginBottom:8}}>💬</div>
                <div style={{fontSize:14,color:C.textMuted}}>No feedback yet</div>
              </div>
            ) : (feedbackItems||[]).map(fb => (
              <div key={fb.id} style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:20,marginBottom:12}}>
                <div style={{fontSize:14,color:C.text,marginBottom:8}}>{fb.message}</div>
                <div style={{fontSize:11,color:C.textMuted}}>{fb.userName || "Anonymous"} · {fb.createdAt ? new Date(fb.createdAt).toLocaleDateString() : ""}</div>
              </div>
            ))}
          </div>
        )}
        {section==="analytics" && (
          <div>
            <div style={{fontSize:20,fontWeight:700,color:C.text,marginBottom:20}}>Analytics</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:32}}>
              {[{label:"Total Users",val:allUsers.length,color:C.accent},{label:"Total Spots",val:spots.length,color:C.blue},{label:"Total Events",val:events.length,color:C.yellow},{label:"Mosaiq Picks",val:spots.filter(s=>s.pick).length,color:C.coral}].map(s=>(
                <div key={s.label} style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:20,textAlign:"center"}}>
                  <div style={{fontSize:32,fontWeight:800,color:s.color}}>{s.val}</div>
                  <div style={{fontSize:12,color:C.textMuted,marginTop:4}}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:20,marginBottom:16}}>
              <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:16}}>Top interests</div>
              {(() => { const counts = {}; allUsers.forEach(u => (u.interests||[]).forEach(i => { counts[i]=(counts[i]||0)+1; })); return Object.entries(counts).sort((a,b)=>b[1]-a[1]).slice(0,6).map(([interest,count])=>( <div key={interest} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}><span style={{fontSize:13,color:C.text,flex:1}}>{interest}</span><div style={{height:8,width:Math.max(20,(count/Math.max(1,allUsers.length))*200),background:C.accent,borderRadius:99}} /><span style={{fontSize:12,color:C.textMuted,width:24,textAlign:"right"}}>{count}</span></div> )); })()}
            </div>
            <div style={{background:C.surface,border:"1.5px solid "+C.border,borderRadius:14,padding:20}}>
              <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:16}}>Most saved spots</div>
              {[...spots].sort((a,b)=>(b.saves||0)-(a.saves||0)).slice(0,5).map(s=>(
                <div key={s.id} style={{display:"flex",alignItems:"center",gap:12,marginBottom:10}}>
                  <span style={{fontSize:18}}>{s.emoji}</span>
                  <span style={{fontSize:13,color:C.text,flex:1}}>{s.name}</span>
                  <div style={{height:8,width:Math.max(10,((s.saves||0)/Math.max(1,...spots.map(x=>x.saves||0)))*150),background:C.blue,borderRadius:99}} />
                  <span style={{fontSize:12,color:C.textMuted,width:24,textAlign:"right"}}>{s.saves||0}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function MosaiqApp() {
  const isAdmin = window.location.pathname === "/admin";
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const [authUser, setAuthUser] = useState(undefined); // undefined=checking, null=logged out
  const [userProfile, setUserProfile] = useState(undefined); // undefined=checking, null=no profile yet
  const [spots, setSpots] = useState([]);
  const [events, setEvents] = useState([]);
  const [pendingEvents, setPendingEvents] = useState([]);
  const [feedbackItems, setFeedbackItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("explore");

  // Auth state listener + real-time user profile
  useEffect(() => {
    let unsubProfile = null;
    const unsubAuth = onAuthStateChanged(auth, u => {
      setAuthUser(u || null);
      if (unsubProfile) { unsubProfile(); unsubProfile = null; }
      if (u) {
        unsubProfile = onSnapshot(doc(db, "users", u.uid), snap => {
          setUserProfile(snap.exists() ? { id: u.uid, ...snap.data() } : null);
        });
      } else {
        setUserProfile(null);
      }
    });
    return () => { unsubAuth(); if (unsubProfile) unsubProfile(); };
  }, []);

  // Firestore data listeners
  useEffect(() => {
    const unsubSpots = onSnapshot(spotsCol, async snap => {
      if (snap.empty) {
        for (const spot of DEFAULT_SPOTS) {
          const { id, ...data } = spot;
          await setDoc(doc(db, "spots", String(id)), data);
        }
      } else {
        setSpots(snap.docs.map(d => ({ ...d.data(), id: d.id })));
        setLoading(false);
      }
    });
    const unsubEvents = onSnapshot(eventsCol, async snap => {
      if (snap.empty) {
        for (const event of DEFAULT_EVENTS) {
          const { id, ...data } = event;
          await setDoc(doc(db, "events", String(id)), data);
        }
      } else {
        setEvents(snap.docs.map(d => ({ ...d.data(), id: d.id })));
      }
    });
    const unsubPending = onSnapshot(pendingEventsCol, snap => {
      setPendingEvents(snap.docs.map(d => ({ ...d.data(), id: d.id })));
    });
    const unsubFeedback = onSnapshot(feedbackCol, snap => {
      setFeedbackItems(snap.docs.map(d => ({ ...d.data(), id: d.id })).sort((a,b) => b.createdAt?.localeCompare(a.createdAt||"")));
    });
    return () => { unsubSpots(); unsubEvents(); unsubPending(); unsubFeedback(); };
  }, []);

  // Loading splash
  if ((authUser === undefined && !isAdmin) || loading) return (
    <div style={{ minHeight: "100vh", background: "#1E3D1A", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "system-ui" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 16 }}>
          {["#F7F5F0","#2C6B7A","#B8860B","#A0522D"].map((c,i) => <div key={i} style={{ width: 10, height: 10, borderRadius: 3, background: c }} />)}
        </div>
        <div style={{ fontSize: 28, fontWeight: 800, color: "#F7F5F0", letterSpacing: "-0.5px" }}>mosaiq</div>
        <div style={{ fontSize: 13, color: "#C8D9C5", marginTop: 8 }}>Loading...</div>
      </div>
    </div>
  );

  // Admin bypass — after loading so pendingEvents/feedbackItems are populated
  if (isAdmin) {
    if (!adminLoggedIn) return <AdminLogin onLogin={() => setAdminLoggedIn(true)} />;
    return <AdminDashboard spots={spots} events={events} onLogout={() => setAdminLoggedIn(false)} pendingEvents={pendingEvents} feedbackItems={feedbackItems} />;
  }

  // Not logged in → login screen
  if (!authUser) return <LoginScreen />;

  // Logged in but no profile → onboarding
  if (!userProfile) return <OnboardingFlow user={authUser} onComplete={async () => {
    const snap = await getDoc(doc(db, "users", authUser.uid));
    setUserProfile(snap.exists() ? { id: authUser.uid, ...snap.data() } : null);
  }} />;
  const isDesktop = window.innerWidth >= 768;
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 0; }
        body, button, input, select, textarea { font-family: 'DM Sans', system-ui, sans-serif; }
        input::placeholder { color: #A0B09B; }
        input:focus { border-color: #2D5C27 !important; outline: none; }
        select:focus { outline: none; }
        textarea:focus { border-color: #2D5C27 !important; outline: none; }
        html, body, #root { height: 100%; }
      `}</style>
      <FeedbackButton userProfile={userProfile} />
      {isDesktop ? (
        <div style={{ display:"flex", minHeight:"100vh", background:C.bg, fontFamily:"system-ui" }}>
          <div style={{ width:240, background:C.surface, borderRight:"1px solid "+C.border, display:"flex", flexDirection:"column", position:"fixed", top:0, left:0, height:"100vh", zIndex:100 }}>
            <div style={{ padding:"28px 24px 20px" }}>
              <div style={{ display:"flex", gap:4, marginBottom:10 }}>{[C.accent,C.blue,C.yellow,C.coral].map((cl,i)=><div key={i} style={{width:8,height:8,borderRadius:2,background:cl}}/>)}</div>
              <span style={{ fontSize:22, fontWeight:800, color:C.accent, letterSpacing:"-0.5px" }}>mosaiq</span>
              <div style={{ fontSize:11, color:C.textMuted, marginTop:2 }}>Luxembourg City</div>
            </div>
            <div style={{ flex:1, padding:"0 12px" }}>
              {[{id:"explore",icon:"🏠",label:"Home"},{id:"events",icon:"📅",label:"Events"},{id:"spots",icon:"📍",label:"Spots"},{id:"profile",icon:"👤",label:"Profile"}].map(item => (
                <button key={item.id} onClick={() => setTab(item.id)} style={{ width:"100%", display:"flex", alignItems:"center", gap:12, padding:"11px 14px", borderRadius:12, background:tab===item.id?C.accentLight:"none", border:"none", cursor:"pointer", fontFamily:"system-ui", marginBottom:4 }}>
                  <span style={{ fontSize:18 }}>{item.icon}</span>
                  <span style={{ fontSize:14, fontWeight:tab===item.id?700:500, color:tab===item.id?C.accent:C.textMuted }}>{item.label}</span>
                </button>
              ))}
            </div>
            {userProfile && (
              <div style={{ padding:"16px 20px", borderTop:"1px solid "+C.border, display:"flex", alignItems:"center", gap:10 }}>
                <div style={{ width:36, height:36, borderRadius:"50%", background:C.accentLight, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>{userProfile.avatar}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:700, color:C.text, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{userProfile.name}</div>
                  <div style={{ fontSize:11, color:C.textMuted }}>@{userProfile.username}</div>
                </div>
              </div>
            )}
          </div>
          <div style={{ marginLeft:240, flex:1, minHeight:"100vh", display:"flex", flexDirection:"column" }}>
            <div style={{ maxWidth:680, width:"100%", margin:"0 auto", flex:1, display:"flex", flexDirection:"column", padding:"0 0 40px" }}>
              {tab==="explore" && <ExploreTab spots={spots} events={events} userProfile={userProfile} setTab={setTab}/>}
              {tab==="events" && <EventsTab events={events} userProfile={userProfile}/>}
              {tab==="spots" && <SpotsTab spots={spots} userProfile={userProfile}/>}
              {tab==="profile" && <ProfileTab spots={spots} events={events} userProfile={userProfile} onSignOut={() => signOut(auth)} setTab={setTab}/>}
            </div>
          </div>
        </div>
      ) : (
        <div style={{ height:"100vh", background:C.bg, display:"flex", flexDirection:"column", fontFamily:"system-ui", overflow:"hidden" }}>
          <div style={{ padding:"12px 20px 4px", display:"flex", alignItems:"center", justifyContent:"space-between", background:C.bg, borderBottom:"1px solid "+C.border, flexShrink:0 }}>
            <div style={{ display:"flex", alignItems:"center", gap:6 }}>
              <div style={{ display:"flex", gap:3 }}>{[C.accent,C.blue,C.yellow,C.coral].map((cl,i)=><div key={i} style={{width:6,height:6,borderRadius:2,background:cl}}/>)}</div>
              <span style={{ fontSize:16, fontWeight:800, color:C.accent, letterSpacing:"-0.3px" }}>mosaiq</span>
            </div>
            {userProfile && (
              <div onClick={() => setTab("profile")} style={{ width:34, height:34, borderRadius:"50%", background:C.accentLight, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, cursor:"pointer" }}>{userProfile.avatar}</div>
            )}
          </div>
          <div style={{ flex:1, overflow:"hidden", position:"relative", display:"flex", flexDirection:"column" }}>
            {tab==="explore" && <ExploreTab spots={spots} events={events} userProfile={userProfile} setTab={setTab}/>}
            {tab==="events" && <EventsTab events={events} userProfile={userProfile}/>}
            {tab==="spots" && <SpotsTab spots={spots} userProfile={userProfile}/>}
            {tab==="profile" && <ProfileTab spots={spots} events={events} userProfile={userProfile} onSignOut={() => signOut(auth)} setTab={setTab}/>}
            <BottomNav tab={tab} setTab={setTab}/>
          </div>
        </div>
      )}
    </>
  );
}